

// import React, { useState, useEffect } from 'react';
// import {
//     FaPlus, FaEye, FaEdit, FaTrash, FaTimes,
//     FaUser, FaEnvelope, FaPhone, FaBuilding,
//     FaMapMarkerAlt, FaCalendarAlt, FaUtensils,
//     FaCheckCircle, FaSearch, FaFilter, FaClock,
//     FaSpinner, FaSync, FaChevronDown, FaUsers,
//     FaClipboardList, FaChartBar, FaPaperPlane,
//     FaUpload, FaDownload, FaFileExcel
// } from 'react-icons/fa';
// import {
//     getAllEnquiries,
//     createEnquiry,
//     updateEnquiry,
//     deleteEnquiry,
//     ENUMS,
//     addItemsToEnquiry
// } from '../../../Servicefile/salesService';
// import GoogleMapPicker from '../../../GoogleMapPicker';

// const ManagerEnquiry = () => {
//     // ============================================
//     // STATE
//     // ============================================
//     const [enquiries, setEnquiries] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [submitting, setSubmitting] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');
//     const ADMIN_ID = localStorage.getItem("userId"); // You can get this from localStorage or props

//     // Date filter states - Same as SalesEnquiry
//     const [dateFilter, setDateFilter] = useState('all');
//     const [customStartDate, setCustomStartDate] = useState('');
//     const [customEndDate, setCustomEndDate] = useState('');
//     const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
//     const [showCustomDateModal, setShowCustomDateModal] = useState(false);

//     // Modal states
//     const [showCreateModal, setShowCreateModal] = useState(false);
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [showViewModal, setShowViewModal] = useState(false);

//     // Selected enquiry
//     const [selectedEnquiry, setSelectedEnquiry] = useState(null);
//     const [editingEnquiry, setEditingEnquiry] = useState(null);

//     // Stats
//     // Replace your stats state with this:
//     const [stats, setStats] = useState({
//         total: 0,
//         approved: 0,
//         inProgress: 0,
//         completed: 0,
//         rejected: 0
//     });

//     // Date filter helper functions - Same as SalesEnquiry
//     const getDateRange = (filterType) => {
//         const today = new Date();
//         const start = new Date();
//         const end = new Date();

//         switch (filterType) {
//             case 'today':
//                 start.setHours(0, 0, 0, 0);
//                 end.setHours(23, 59, 59, 999);
//                 break;
//             case 'yesterday':
//                 start.setDate(today.getDate() - 1);
//                 start.setHours(0, 0, 0, 0);
//                 end.setDate(today.getDate() - 1);
//                 end.setHours(23, 59, 59, 999);
//                 break;
//             case 'week':
//                 const day = today.getDay();
//                 start.setDate(today.getDate() - day);
//                 start.setHours(0, 0, 0, 0);
//                 end.setDate(today.getDate() + (6 - day));
//                 end.setHours(23, 59, 59, 999);
//                 break;
//             case 'month':
//                 start.setDate(1);
//                 start.setHours(0, 0, 0, 0);
//                 end.setHours(23, 59, 59, 999);
//                 break;
//             case 'custom':
//                 if (customStartDate && customEndDate) {
//                     return { from: new Date(customStartDate), to: new Date(customEndDate) };
//                 }
//                 return null;
//             default:
//                 return null;
//         }
//         return { from: start, to: end };
//     };

//     const applyDateFilter = (enquiriesList) => {
//         if (dateFilter === 'all') return enquiriesList;

//         const range = getDateRange(dateFilter);
//         if (!range) return enquiriesList;

//         return enquiriesList.filter(enquiry => {
//             const dateStr = enquiry.createdAt || enquiry.eventDate;
//             if (!dateStr) return false;
//             const enquiryDate = new Date(dateStr);
//             return enquiryDate >= range.from && enquiryDate <= range.to;
//         });
//     };

//     const getDateFilterLabel = () => {
//         switch (dateFilter) {
//             case 'all': return 'All Dates';
//             case 'today': return 'Today';
//             case 'yesterday': return 'Yesterday';
//             case 'week': return 'This Week';
//             case 'month': return 'This Month';
//             case 'custom': return 'Custom Range';
//             default: return 'All Dates';
//         }
//     };

//     // ============================================
//     // FORM DATA - Same as SalesEnquiry
//     // ============================================
//     const [formData, setFormData] = useState({
//         source: 'APP',
//         sourceBy: '',
//         fullName: '',
//         email: '',
//         phoneNumber: '',
//         event: 'EVENT',
//         eventType: 'WEDDING',
//         eventDate: '',
//         eventTime: '',
//         fromDate: '',
//         toDate: '',
//         fullAddress: '',
//         city: '',
//         state: '',
//         country: 'India',
//         companyName: '',
//         vegPlates: 0,
//         nonVegPlates: 0,
//         mixedPlates: 0,
//         additionalRequests: '',
//         adminPermision: false,
//         leadStatus: 'PENDING',
//         budget: 0,
//         latitude: 0,
//         longitude: 0,
//         pincode: '',
//         gstRequirement: '',
//         dishId: [],
//         addOns: []
//     });

//     const addOnOptions = [
//         { addOnType: 'SERVICE_BOYS', label: 'Service Boys', selected: false, quantity: 0 },
//         { addOnType: 'PAPER_PLATES', label: 'Paper Plates', selected: false, quantity: 0 },
//         { addOnType: 'WATER_BOTTLES', label: 'Water Bottles', selected: false, quantity: 0 },
//         { addOnType: 'DISPOSABLE_CUPS', label: 'Disposable Cups', selected: false, quantity: 0 },
//         { addOnType: 'TISSUE_PAPER', label: 'Tissue Paper', selected: false, quantity: 0 }
//     ];
//     const [addOns, setAddOns] = useState(addOnOptions);
//     const [selectedDishIds, setSelectedDishIds] = useState([]);
//     const [showMapPicker, setShowMapPicker] = useState(false);
//     const [mapPickerFor, setMapPickerFor] = useState('create');

//     // ============================================
//     // API CALLS - Same as SalesEnquiry
//     // ============================================
//     const fetchEnquiries = async () => {
//         setLoading(true);
//         try {
//             const data = await getAllEnquiries();
//             // Sort by createdAt - newest first
//             const sortedData = (data || []).sort((a, b) => {
//                 const dateA = new Date(a.createdAt);
//                 const dateB = new Date(b.createdAt);
//                 return dateB - dateA; // Descending - newest first
//             });
//             setEnquiries(sortedData);
//             calculateStats(sortedData);
//         } catch (error) {
//             console.error('Error fetching enquiries:', error);
//             alert('Failed to fetch enquiries');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const calculateStats = (data) => {
//         const total = data.length;

//         // Approved = APPROVED
//         const approved = data.filter(e => e.leadStatus === 'APPROVED').length;

//         // In Progress = PAYMENT_RECEIVED + ASSIGNED + ACCEPT + ACCEPTED
//         const inProgress = data.filter(e =>
//             e.leadStatus === 'PAYMENT_RECEIVED' ||
//             e.leadStatus === 'ASSIGNED' ||
//             e.leadStatus === 'ACCEPT' ||
//             e.leadStatus === 'ACCEPTED'
//         ).length;

//         // Completed = CLOSED
//         const completed = data.filter(e => e.leadStatus === 'CLOSED').length;

//         // Rejected = REJECTED
//         const rejected = data.filter(e => e.leadStatus === 'REJECTED').length;

//         setStats({ total, approved, inProgress, completed, rejected });
//     };

//     // ============================================
//     // HANDLERS - Same as SalesEnquiry
//     // ============================================
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({ ...prev, [name]: value }));
//     };

//     const handleAddOnToggle = (index) => {
//         const updated = [...addOns];
//         updated[index].selected = !updated[index].selected;
//         if (!updated[index].selected) {
//             updated[index].quantity = 0;
//         }
//         setAddOns(updated);
//     };

//     const handleAddOnQuantity = (index, value) => {
//         const updated = [...addOns];
//         updated[index].quantity = parseInt(value) || 0;
//         setAddOns(updated);
//     };

//     const handleDishSelect = (dishId) => {
//         setSelectedDishIds(prev => {
//             if (prev.includes(dishId)) {
//                 return prev.filter(id => id !== dishId);
//             } else {
//                 return [...prev, dishId];
//             }
//         });
//     };

//     const resetForm = () => {
//         setFormData({
//             source: 'APP',
//             sourceBy: '',
//             fullName: '',
//             email: '',
//             phoneNumber: '',
//             event: 'EVENT',
//             eventType: 'WEDDING',
//             eventDate: '',
//             eventTime: '',
//             fromDate: '',
//             toDate: '',
//             fullAddress: '',
//             city: '',
//             state: '',
//             country: 'India',
//             companyName: '',
//             vegPlates: 0,
//             nonVegPlates: 0,
//             mixedPlates: 0,
//             additionalRequests: '',
//             adminPermision: false,
//             leadStatus: 'PENDING',
//             budget: 0,
//             latitude: 0,
//             longitude: 0,
//             pincode: '',
//             gstRequirement: '',
//             dishId: [],
//             addOns: []
//         });
//         setAddOns(addOnOptions);
//         setSelectedDishIds([]);
//         setEditingEnquiry(null);
//     };

//     const handleLocationSelect = (locationData) => {
//         setFormData(prev => ({
//             ...prev,
//             latitude: locationData.latitude,
//             longitude: locationData.longitude,
//             fullAddress: locationData.address,
//             city: locationData.address.split(',').slice(-3, -2)[0]?.trim() || prev.city,
//             state: locationData.address.split(',').slice(-2, -1)[0]?.trim() || prev.state,
//         }));
//     };

//     const formatDateForAPI = (dateStr) => {
//         if (!dateStr) return '';
//         const parts = dateStr.split('-');
//         return `${parts[2]}-${parts[1]}-${parts[0]}`;
//     };

//     const getMinDate = () => {
//         const date = new Date();
//         date.setDate(date.getDate() + 2);
//         return date.toISOString().split('T')[0];
//     };

//     const getMaxDate = () => {
//         const date = new Date();
//         date.setFullYear(date.getFullYear() + 3);
//         return date.toISOString().split('T')[0];
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!formData.fullName) {
//             alert('Please enter full name');
//             return;
//         }
//         if (!formData.email) {
//             alert('Please enter email');
//             return;
//         }
//         if (!formData.phoneNumber) {
//             alert('Please enter phone number');
//             return;
//         }

//         if (formData.event === 'EVENT') {
//             if (!formData.eventDate) {
//                 alert('Please select event date');
//                 return;
//             }
//         } else if (formData.event === 'DAILY') {
//             if (!formData.fromDate || !formData.toDate) {
//                 alert('Please select from and to dates');
//                 return;
//             }
//         }

//         const selectedAddOns = addOns
//             .filter(a => a.selected)
//             .map(a => ({
//                 addOnType: a.addOnType,
//                 quantity: a.quantity || 1,
//                 selected: true
//             }));

//         const requestBody = {
//             ...formData,
//             eventDate: formData.eventDate ? formatDateForAPI(formData.eventDate) : '',
//             fromDate: formData.fromDate ? formatDateForAPI(formData.fromDate) : '',
//             toDate: formData.toDate ? formatDateForAPI(formData.toDate) : '',
//             eventTime: formData.eventTime || '',
//             addOns: selectedAddOns,
//             dishId: selectedDishIds,
//             pincode: parseInt(formData.pincode) || 0,
//             budget: parseFloat(formData.budget) || 0,
//             vegPlates: parseInt(formData.vegPlates) || 0,
//             nonVegPlates: parseInt(formData.nonVegPlates) || 0,
//             mixedPlates: parseInt(formData.mixedPlates) || 0
//         };

//         setSubmitting(true);
//         try {
//             await createEnquiry(requestBody);
//             alert('Enquiry created successfully!');
//             setShowCreateModal(false);
//             resetForm();
//             fetchEnquiries();
//         } catch (error) {
//             console.error('Error creating enquiry:', error);
//             alert(error.response?.data?.message || 'Failed to create enquiry');
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const handleUpdateSubmit = async (e) => {
//         e.preventDefault();

//         if (!formData.fullName) {
//             alert('Please enter full name');
//             return;
//         }
//         if (!formData.email) {
//             alert('Please enter email');
//             return;
//         }
//         if (!formData.phoneNumber) {
//             alert('Please enter phone number');
//             return;
//         }

//         const selectedAddOns = addOns
//             .filter(a => a.selected)
//             .map(a => ({
//                 addOnType: a.addOnType,
//                 quantity: a.quantity || 1,
//                 selected: true
//             }));

//         const requestBody = {
//             source: formData.source || 'APP',
//             sourceBy: formData.sourceBy || '',
//             fullName: formData.fullName,
//             email: formData.email,
//             phoneNumber: formData.phoneNumber,
//             event: formData.event || 'EVENT',
//             eventType: formData.eventType || 'WEDDING',
//             eventDate: formData.eventDate ? formatDateForAPI(formData.eventDate) : '',
//             eventTime: formData.eventTime || '',
//             fromDate: formData.fromDate ? formatDateForAPI(formData.fromDate) : '',
//             toDate: formData.toDate ? formatDateForAPI(formData.toDate) : '',
//             fullAddress: formData.fullAddress || '',
//             city: formData.city || '',
//             state: formData.state || '',
//             country: formData.country || 'India',
//             companyName: formData.companyName || '',
//             vegPlates: parseInt(formData.vegPlates) || 0,
//             nonVegPlates: parseInt(formData.nonVegPlates) || 0,
//             mixedPlates: parseInt(formData.mixedPlates) || 0,
//             additionalRequests: formData.additionalRequests || '',
//             adminPermision: formData.adminPermision || false,
//             leadStatus: formData.leadStatus || 'PENDING',
//             budget: parseFloat(formData.budget) || 0,
//             latitude: parseFloat(formData.latitude) || 0,
//             longitude: parseFloat(formData.longitude) || 0,
//             pincode: parseInt(formData.pincode) || 0,
//             gstRequirement: formData.gstRequirement || '',
//             addOns: selectedAddOns
//         };

//         setSubmitting(true);
//         try {
//             const enquiryId = editingEnquiry.id || editingEnquiry.enquiryId;
//             await updateEnquiry(enquiryId, requestBody);

//             if (selectedDishIds.length > 0) {
//                 await addItemsToEnquiry(enquiryId, selectedDishIds);
//             }

//             alert('Enquiry updated successfully!');
//             setShowEditModal(false);
//             resetForm();
//             fetchEnquiries();
//         } catch (error) {
//             console.error('Error updating enquiry:', error);
//             alert(error.response?.data?.message || 'Failed to update enquiry');
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const handleDelete = async (id) => {
//         if (!window.confirm('Are you sure you want to delete this enquiry?')) return;

//         try {
//             await deleteEnquiry(id);
//             alert('Enquiry deleted successfully!');
//             fetchEnquiries();
//         } catch (error) {
//             console.error('Error deleting enquiry:', error);
//             alert('Failed to delete enquiry');
//         }
//     };

//     const handleEditClick = (enquiry) => {
//         setEditingEnquiry(enquiry);
//         setFormData({
//             source: enquiry.source || 'APP',
//             sourceBy: enquiry.sourceBy || '',
//             fullName: enquiry.fullName || '',
//             email: enquiry.email || '',
//             phoneNumber: enquiry.phoneNumber || '',
//             event: enquiry.event || 'EVENT',
//             eventType: enquiry.eventType || 'WEDDING',
//             eventDate: enquiry.eventDate || '',
//             eventTime: enquiry.eventTime || '',
//             fromDate: enquiry.fromDate || '',
//             toDate: enquiry.toDate || '',
//             fullAddress: enquiry.fullAddress || '',
//             city: enquiry.city || '',
//             state: enquiry.state || '',
//             country: enquiry.country || 'India',
//             companyName: enquiry.companyName || '',
//             vegPlates: enquiry.vegPlates || 0,
//             nonVegPlates: enquiry.nonVegPlates || 0,
//             mixedPlates: enquiry.mixedPlates || 0,
//             additionalRequests: enquiry.additionalRequests || '',
//             adminPermision: enquiry.adminPermision || false,
//             leadStatus: enquiry.leadStatus || 'PENDING',
//             budget: enquiry.budget || 0,
//             latitude: enquiry.latitude || 0,
//             longitude: enquiry.longitude || 0,
//             pincode: enquiry.pincode || '',
//             gstRequirement: enquiry.gstRequirement || '',
//             dishId: enquiry.dishId || [],
//             addOns: enquiry.addOns || []
//         });
//         setSelectedDishIds(enquiry.dishId || []);

//         if (enquiry.addOns && enquiry.addOns.length > 0) {
//             const updatedAddOns = addOnOptions.map(option => {
//                 const existing = enquiry.addOns.find(a => a.addOnType === option.addOnType);
//                 return {
//                     ...option,
//                     selected: !!existing,
//                     quantity: existing?.quantity || 0
//                 };
//             });
//             setAddOns(updatedAddOns);
//         } else {
//             setAddOns(addOnOptions);
//         }

//         setShowEditModal(true);
//     };

//     const handleViewClick = (enquiry) => {
//         setSelectedEnquiry(enquiry);
//         setShowViewModal(true);
//     };

//     // ============================================
//     // FILTERS
//     // ============================================
//     // Replace your existing filteredEnquiries with this:
//     const filteredEnquiries = applyDateFilter(enquiries).filter(enquiry => {
//         const matchesSearch =
//             (enquiry.fullName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (enquiry.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (enquiry.companyName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (enquiry.city || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (enquiry.sourceBy || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (enquiry.source || '').toLowerCase().includes(searchTerm.toLowerCase());

//         return matchesSearch;
//     });

//     const clearFilters = () => {
//         setSearchTerm('');
//         setStartDate('');
//         setEndDate('');
//     };

//     const getStatusBadge = (status) => {
//         const statusMap = {
//             'PENDING': { bg: '#FEF3C7', color: '#92400E', label: 'Pending' },
//             'APPROVED': { bg: '#D1FAE5', color: '#065F46', label: 'Approved' },
//             'PAYMENT_RECEIVED': { bg: '#DBEAFE', color: '#1E40AF', label: 'Quoted' },
//             'ASSIGNED': { bg: '#DBEAFE', color: '#1E40AF', label: 'Assigned' },
//             'ACCEPT': { bg: '#DBEAFE', color: '#1E40AF', label: 'Accept' },
//             'ACCEPTED': { bg: '#DBEAFE', color: '#1E40AF', label: 'Accepted' },
//             'CLOSED': { bg: '#D1FAE5', color: '#065F46', label: 'Closed' },
//             'REJECTED': { bg: '#FEE2E2', color: '#991B1B', label: 'Rejected' }
//         };
//         const statusInfo = statusMap[status] || statusMap['PENDING'];
//         return (
//             <span style={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 gap: '4px',
//                 padding: '4px 12px',
//                 borderRadius: '20px',
//                 fontSize: '11px',
//                 fontWeight: 600,
//                 background: statusInfo.bg,
//                 color: statusInfo.color
//             }}>
//                 {statusInfo.label}
//             </span>
//         );
//     };

//     const formatDate = (dateStr) => {
//         if (!dateStr) return '-';
//         try {
//             const date = new Date(dateStr);
//             return date.toLocaleDateString('en-IN', {
//                 day: '2-digit',
//                 month: 'short',
//                 year: 'numeric'
//             });
//         } catch {
//             return dateStr;
//         }
//     };

//     // ============================================
//     // EFFECTS
//     // ============================================
//     useEffect(() => {
//         fetchEnquiries();
//     }, []);

//     // ============================================
//     // RENDER
//     // ============================================
//     return (
//         <div style={containerStyle}>
//             {/* Header */}
//             <div style={headerStyle}>
//                 <div style={headerLeftStyle}>
//                     <div style={headerIconStyle}>
//                         <FaUsers size={22} />
//                     </div>
//                     <div>
//                         <h2 style={titleStyle}>Manager Enquiry</h2>
//                         <p style={subtitleStyle}>Manage and track all your enquiries from various sources</p>
//                     </div>
//                 </div>
//                 <button
//                     onClick={() => { resetForm(); setShowCreateModal(true); }}
//                     style={createButtonStyle}
//                     onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
//                     onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//                 >
//                     <FaPlus size={14} />
//                     New Enquiry
//                 </button>
//             </div>

//             {/* Stats Cards - Sourcing specific */}
//             {/* Stats Cards */}
//             <div style={statsContainerStyle}>
//                 {/* Total */}
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#EEF2FF' }}>
//                         <FaClipboardList style={{ color: '#4F46E5' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.total}</div>
//                         <div style={statLabelStyle}>Total</div>
//                     </div>
//                 </div>

//                 {/* Approved */}
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#D1FAE5' }}>
//                         <FaCheckCircle style={{ color: '#059669' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.approved}</div>
//                         <div style={statLabelStyle}>Approved</div>
//                     </div>
//                 </div>

//                 {/* In Progress */}
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#DBEAFE' }}>
//                         <FaSync style={{ color: '#1E40AF' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.inProgress}</div>
//                         <div style={statLabelStyle}>In Progress</div>
//                     </div>
//                 </div>

//                 {/* Completed */}
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#D1FAE5' }}>
//                         <FaCheckCircle style={{ color: '#059669' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.completed}</div>
//                         <div style={statLabelStyle}>Completed</div>
//                     </div>
//                 </div>

//                 {/* Rejected */}
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#FEE2E2' }}>
//                         <FaTimes style={{ color: '#DC2626' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.rejected}</div>
//                         <div style={statLabelStyle}>Rejected</div>
//                     </div>
//                 </div>
//             </div>
//             {/* Search and Filter */}
//             {/* Search and Filter */}
//             <div style={searchFilterContainerStyle}>
//                 <div style={searchContainerStyle}>
//                     <FaSearch style={searchIconStyle} />
//                     <input
//                         type="text"
//                         placeholder="Search by name, email, source, city..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         style={searchInputStyle}
//                     />
//                 </div>

//                 {/* Date Filter - Same as SalesEnquiry */}
//                 <div style={dateFilterContainerStyle}>
//                     <FaCalendarAlt style={filterIconStyle} />
//                     <select
//                         value={dateFilter}
//                         onChange={(e) => {
//                             const value = e.target.value;
//                             setDateFilter(value);
//                             if (value === 'custom') {
//                                 setShowCustomDateModal(true);
//                             } else {
//                                 setShowCustomDatePicker(false);
//                             }
//                         }}
//                         style={filterSelectStyle}
//                     >
//                         <option value="all" style={{ padding: "10px" }}>All Dates</option>
//                         <option value="today" style={{ padding: "10px" }}>Today</option>
//                         <option value="yesterday" style={{ padding: "10px" }}>Yesterday</option>
//                         <option value="week" style={{ padding: "10px" }}>This Week</option>
//                         <option value="month" style={{ padding: "10px" }}>This Month</option>
//                         <option value="custom" style={{ padding: "10px", margin: "10px" }}>Custom Range</option>
//                     </select>
//                     <FaChevronDown style={{ color: '#9CA3AF', fontSize: '10px', marginLeft: '4px' }} />
//                 </div>

//                 {/* Custom Date Range Modal */}
//                 {showCustomDateModal && (
//                     <div style={customDateModalOverlay} onClick={() => setShowCustomDateModal(false)}>
//                         <div style={customDateModalStyle} onClick={(e) => e.stopPropagation()}>
//                             <div style={customDateModalHeader}>
//                                 <h3 style={customDateModalTitle}>Select Custom Date Range</h3>
//                                 <button
//                                     onClick={() => setShowCustomDateModal(false)}
//                                     style={customDateModalClose}
//                                 >
//                                     <FaTimes />
//                                 </button>
//                             </div>
//                             <div style={customDateModalBody}>
//                                 <div style={customDateModalInputGroup}>
//                                     <label style={customDateModalLabel}>From Date</label>
//                                     <input
//                                         type="date"
//                                         value={customStartDate}
//                                         onChange={(e) => setCustomStartDate(e.target.value)}
//                                         style={customDateModalInput}
//                                         max={customEndDate || undefined}
//                                     />
//                                 </div>
//                                 <div style={customDateModalInputGroup}>
//                                     <label style={customDateModalLabel}>To Date</label>
//                                     <input
//                                         type="date"
//                                         value={customEndDate}
//                                         onChange={(e) => setCustomEndDate(e.target.value)}
//                                         style={customDateModalInput}
//                                         min={customStartDate || undefined}
//                                         max={new Date().toISOString().split('T')[0]}
//                                     />
//                                 </div>
//                             </div>
//                             <div style={customDateModalFooter}>
//                                 <button
//                                     onClick={() => {
//                                         setShowCustomDateModal(false);
//                                         setCustomStartDate('');
//                                         setCustomEndDate('');
//                                     }}
//                                     style={customDateModalCancel}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     onClick={() => {
//                                         if (customStartDate && customEndDate) {
//                                             setDateFilter('custom');
//                                             setShowCustomDateModal(false);
//                                             setShowCustomDatePicker(false);
//                                         } else {
//                                             alert('Please select both start and end dates');
//                                         }
//                                     }}
//                                     style={customDateModalApply}
//                                 >
//                                     Apply Range
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </div>

//             {/* Table */}
//             <div style={tableCardStyle}>
//                 {loading ? (
//                     <div style={loadingStyle}>
//                         <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={32} color="#4F46E5" />
//                         <p>Loading enquiries...</p>
//                     </div>
//                 ) : (
//                     <div style={tableWrapperStyle}>
//                         <table style={tableStyle}>
//                             <thead>
//                                 <tr>
//                                     <th style={{ ...thStyle, width: '4%', textAlign: 'center' }}>#</th>
//                                     <th style={{ ...thStyle, width: '4%', textAlign: 'center' }}>ID</th>
//                                     <th style={{ ...thStyle, width: '10%', textAlign: 'left' }}>Customer</th>
//                                     <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Source</th>
//                                     <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Source By</th>
//                                     <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Event</th>
//                                     <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Date</th>
//                                     <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>City</th>
//                                     <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Budget</th>
//                                     <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Status</th>
//                                     <th style={{ ...thStyle, width: '26%', textAlign: 'center' }}>Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filteredEnquiries.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="10" style={emptyStateStyle}>
//                                             <div style={emptyStateContentStyle}>
//                                                 <FaUsers size={40} color="#D1D5DB" />
//                                                 <p>No enquiries found</p>
//                                                 <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
//                                                     Try adjusting your search or filter
//                                                 </span>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ) : (
//                                     filteredEnquiries.map((enquiry, index) => (
//                                         <tr key={enquiry.id || enquiry.enquiryId || index} style={tableRowStyle}>
//                                             <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 500, color: '#9CA3AF' }}>
//                                                 {index + 1}
//                                             </td>
//                                              <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 500, color: '#9CA3AF' }}>
//                                                 {enquiry.id}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'left' }}>
//                                                 <div style={customerCellStyle}>
//                                                     <div style={avatarStyle}>
//                                                         {(enquiry.fullName || '?')[0].toUpperCase()}
//                                                     </div>
//                                                     <div>
//                                                         <div style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>
//                                                             {enquiry.fullName || '-'}
//                                                         </div>
//                                                         <div style={{ fontSize: '12px', color: '#6B7280' }}>
//                                                             {enquiry.email || '-'}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 <span style={sourceBadgeStyle}>
//                                                     {enquiry.source || '-'}
//                                                 </span>
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 {enquiry.sourceBy || '-'}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 <span style={eventBadgeStyle}>
//                                                     {enquiry.eventType || '-'}
//                                                 </span>
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center', fontSize: '12px', color: '#374151' }}>
//                                                 {enquiry.event === 'EVENT'
//                                                     ? formatDate(enquiry.eventDate)
//                                                     : `${formatDate(enquiry.fromDate)} - ${formatDate(enquiry.toDate)}`}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 <span style={cityBadgeStyle}>
//                                                     {enquiry.city || '-'}
//                                                 </span>
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#059669' }}>
//                                                 ₹{Number(enquiry.budget || 0).toLocaleString()}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 {getStatusBadge(enquiry.leadStatus)}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 <div style={actionGroupStyle}>
//                                                     {/* View - Always accessible */}
//                                                     <button
//                                                         style={viewButtonStyle}
//                                                         title="View Details"
//                                                         onClick={() => handleViewClick(enquiry)}
//                                                     >
//                                                         <FaEye size={13} />
//                                                     </button>

//                                                     {/* Edit - Only when status is PENDING */}
//                                                     {enquiry.leadStatus === 'PENDING' && (
//                                                         <button
//                                                             style={editButtonStyle}
//                                                             title="Edit"
//                                                             onClick={() => handleEditClick(enquiry)}
//                                                         >
//                                                             <FaEdit size={13} />
//                                                         </button>
//                                                     )}

//                                                     {/* Delete - Only when status is PENDING */}
//                                                     {enquiry.leadStatus === 'PENDING' && (
//                                                         <button
//                                                             style={deleteButtonStyle}
//                                                             title="Delete"
//                                                             onClick={() => handleDelete(enquiry.id || enquiry.enquiryId)}
//                                                         >
//                                                             <FaTrash size={13} />
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     ))
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}
//             </div>

//             {/* Create Enquiry Modal - Same as SalesEnquiry */}
//             {showCreateModal && (
//                 <EnquiryModal
//                     formData={formData}
//                     setFormData={setFormData}
//                     addOns={addOns}
//                     setAddOns={setAddOns}
//                     selectedDishIds={selectedDishIds}
//                     setSelectedDishIds={setSelectedDishIds}
//                     handleInputChange={handleInputChange}
//                     handleAddOnToggle={handleAddOnToggle}
//                     handleAddOnQuantity={handleAddOnQuantity}
//                     handleDishSelect={handleDishSelect}
//                     handleSubmit={handleSubmit}
//                     resetForm={resetForm}
//                     setShowModal={setShowCreateModal}
//                     submitting={submitting}
//                     getMinDate={getMinDate}
//                     getMaxDate={getMaxDate}
//                     ENUMS={ENUMS}
//                     title="New Enquiry"
//                     submitLabel="Create Enquiry"
//                     showMapPicker={showMapPicker}
//                     setShowMapPicker={setShowMapPicker}
//                     setMapPickerFor={setMapPickerFor}
//                     onLocationSelect={handleLocationSelect}
//                 />
//             )}

//             {/* Edit Enquiry Modal */}
//             {showEditModal && editingEnquiry && (
//                 <EnquiryModal
//                     formData={formData}
//                     setFormData={setFormData}
//                     addOns={addOns}
//                     setAddOns={setAddOns}
//                     selectedDishIds={selectedDishIds}
//                     setSelectedDishIds={setSelectedDishIds}
//                     handleInputChange={handleInputChange}
//                     handleAddOnToggle={handleAddOnToggle}
//                     handleAddOnQuantity={handleAddOnQuantity}
//                     handleDishSelect={handleDishSelect}
//                     handleSubmit={handleUpdateSubmit}
//                     resetForm={resetForm}
//                     setShowModal={setShowEditModal}
//                     submitting={submitting}
//                     getMinDate={getMinDate}
//                     getMaxDate={getMaxDate}
//                     ENUMS={ENUMS}
//                     title="Edit Enquiry"
//                     submitLabel="Update Enquiry"
//                     isEdit={true}
//                     showMapPicker={showMapPicker}
//                     setShowMapPicker={setShowMapPicker}
//                     setMapPickerFor={setMapPickerFor}
//                     onLocationSelect={handleLocationSelect}
//                 />
//             )}

//             {/* View Enquiry Modal */}
//             {showViewModal && selectedEnquiry && (
//                 <div style={modalOverlayStyle} onClick={() => setShowViewModal(false)}>
//                     <div style={{ ...modalStyle, maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
//                         <div style={modalHeaderStyle}>
//                             <div style={modalHeaderLeftStyle}>
//                                 <div style={modalHeaderIconStyle}>
//                                     <FaEye size={18} />
//                                 </div>
//                                 <h3 style={modalTitleStyle}>Enquiry Details</h3>
//                             </div>
//                             <button onClick={() => setShowViewModal(false)} style={modalCloseStyle}>
//                                 <FaTimes />
//                             </button>
//                         </div>

//                         <div style={modalBodyStyle}>
//                             <div style={viewSectionStyle}>
//                                 <h4 style={viewSectionTitleStyle}>Contact Information</h4>
//                                 <div style={viewGridStyle}>
//                                     <div><strong>Name:</strong> {selectedEnquiry.fullName || '-'}</div>
//                                     <div><strong>Company:</strong> {selectedEnquiry.companyName || '-'}</div>
//                                     <div><strong>Email:</strong> {selectedEnquiry.email || '-'}</div>
//                                     <div><strong>Phone:</strong> {selectedEnquiry.phoneNumber || '-'}</div>
//                                     <div><strong>City:</strong> {selectedEnquiry.city || '-'}</div>
//                                     <div><strong>State:</strong> {selectedEnquiry.state || '-'}</div>
//                                 </div>
//                             </div>

//                             <div style={viewSectionStyle}>
//                                 <h4 style={viewSectionTitleStyle}>Enquiry Information</h4>
//                                 <div style={viewGridStyle}>
//                                     <div><strong>Source:</strong> {selectedEnquiry.source || '-'}</div>
//                                     <div><strong>Source By:</strong> {selectedEnquiry.sourceBy || '-'}</div>
//                                     <div><strong>Event:</strong> {selectedEnquiry.eventType || '-'}</div>
//                                     <div><strong>Event Date:</strong> {formatDate(selectedEnquiry.eventDate)}</div>
//                                     <div><strong>Budget:</strong> ₹{Number(selectedEnquiry.budget || 0).toLocaleString()}</div>
//                                     <div><strong>Status:</strong> {getStatusBadge(selectedEnquiry.leadStatus)}</div>
//                                 </div>
//                             </div>

//                             <div style={viewSectionStyle}>
//                                 <h4 style={viewSectionTitleStyle}>Additional Details</h4>
//                                 <div style={viewGridStyle}>
//                                     <div><strong>Veg Plates:</strong> {selectedEnquiry.vegPlates || 0}</div>
//                                     <div><strong>Non-Veg Plates:</strong> {selectedEnquiry.nonVegPlates || 0}</div>
//                                     <div><strong>Mixed Plates:</strong> {selectedEnquiry.mixedPlates || 0}</div>
//                                     <div style={{ gridColumn: '1 / -1' }}>
//                                         <strong>Address:</strong> {selectedEnquiry.fullAddress || '-'}
//                                     </div>
//                                     <div style={{ gridColumn: '1 / -1' }}>
//                                         <strong>Additional Requests:</strong> {selectedEnquiry.additionalRequests || '-'}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div style={formActionStyle}>
//                             <button
//                                 onClick={() => setShowViewModal(false)}
//                                 style={cancelButtonStyle}
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {showMapPicker && (
//                 <GoogleMapPicker
//                     onLocationSelect={handleLocationSelect}
//                     onClose={() => setShowMapPicker(false)}
//                     initialLat={formData.latitude || 17.3850}
//                     initialLng={formData.longitude || 78.4867}
//                     initialAddress={formData.fullAddress || ''}
//                 />
//             )}

//             <style>{`
//                 @keyframes spin { to { transform: rotate(360deg); } }
//                 @keyframes fadeIn {
//                     from { opacity: 0; transform: translateY(-10px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//                 @keyframes slideUp {
//                     from { opacity: 0; transform: translateY(20px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//             `}</style>
//         </div>
//     );
// };

// // ─── EnquiryModal Component ──────────────────────────────────────
// // (Same as SalesEnquiry - reuse the exact same modal)
// // ─── EnquiryModal Component ──────────────────────────────────────
// const EnquiryModal = ({
//     formData,
//     setFormData,
//     addOns,
//     setAddOns,
//     selectedDishIds,
//     setSelectedDishIds,
//     handleInputChange,
//     handleAddOnToggle,
//     handleAddOnQuantity,
//     handleDishSelect,
//     handleSubmit,
//     resetForm,
//     setShowModal,
//     submitting,
//     getMinDate,
//     getMaxDate,
//     ENUMS,
//     title,
//     submitLabel,
//     showMapPicker,
//     setShowMapPicker,
//     setMapPickerFor,
//     onLocationSelect,
//     isEdit = false,
//     dishes = [] // Add this prop with default empty array
// }) => {
//     const availableDishes = dishes.filter(d => d.parentId !== null && d.parentId !== undefined);

//     // Define styles inside the component
//     const modalOverlayStyle = {
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         background: 'rgba(0,0,0,0.5)',
//         backdropFilter: 'blur(4px)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         zIndex: 9999,
//         padding: '20px',
//         animation: 'fadeIn 0.25s ease',
//     };

//     const modalStyle = {
//         background: '#fff',
//         borderRadius: '16px',
//         width: '100%',
//         maxWidth: '720px',
//         maxHeight: '90vh',
//         scrollbarWidth: "none",
//         overflow: 'auto',
//         boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
//         animation: 'slideUp 0.3s ease',
//     };

//     const modalHeaderStyle = {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '20px 24px',
//         borderBottom: '1px solid #F3F4F6',
//         position: 'sticky',
//         top: 0,
//         background: '#fff',
//         zIndex: 1,
//     };

//     const modalHeaderLeftStyle = {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '12px',
//     };

//     const modalHeaderIconStyle = {
//         width: '36px',
//         height: '36px',
//         borderRadius: '10px',
//         background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         color: '#fff',
//     };

//     const modalTitleStyle = {
//         margin: 0,
//         fontSize: '18px',
//         fontWeight: 700,
//         color: '#111827',
//     };

//     const modalCloseStyle = {
//         background: '#F3F4F6',
//         border: 'none',
//         fontSize: '16px',
//         cursor: 'pointer',
//         color: '#6B7280',
//         padding: '6px 10px',
//         borderRadius: '8px',
//         transition: 'all 0.2s ease',
//     };

//     const modalBodyStyle = {
//         padding: '24px',
//     };

//     const formRowStyle = {
//         display: 'grid',
//         gridTemplateColumns: '1fr 1fr',
//         gap: '14px',
//         marginBottom: '14px',
//     };

//     const formGroupStyle = {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '5px',
//     };

//     const labelStyle = {
//         fontSize: '13px',
//         fontWeight: 500,
//         color: '#374151',
//     };

//     const inputStyle = {
//         padding: '10px 12px',
//         border: '1px solid #E5E7EB',
//         borderRadius: '8px',
//         fontSize: '14px',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         background: '#fff',
//         color: '#111827',
//     };

//     const selectStyle = {
//         ...inputStyle,
//         appearance: 'auto',
//     };

//     const textareaStyle = {
//         ...inputStyle,
//         resize: 'vertical',
//         fontFamily: 'inherit',
//         width: '100%',
//     };

//     const sectionStyle = {
//         marginBottom: '20px',
//         paddingBottom: '20px',
//         borderBottom: '1px solid #F3F4F6',
//     };

//     const sectionTitleStyle = {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         fontSize: '14px',
//         fontWeight: 600,
//         color: '#374151',
//         marginBottom: '12px',
//     };

//     const checkboxStyle = {
//         width: '16px',
//         height: '16px',
//         accentColor: '#e66d33',
//         cursor: 'pointer',
//     };

//     const checkboxLabelStyle = {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         cursor: 'pointer',
//         fontSize: '14px',
//         flex: 1,
//     };

//     const addonCardStyle = {
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         padding: '8px 12px',
//         background: '#F9FAFB',
//         borderRadius: '8px',
//         border: '1px solid #F3F4F6',
//     };

//     const addonsGridStyle = {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(2, 1fr)',
//         gap: '8px',
//     };

//     const addonQuantityStyle = {
//         width: '60px',
//         padding: '4px 8px',
//         border: '1px solid #E5E7EB',
//         borderRadius: '6px',
//         fontSize: '13px',
//         textAlign: 'center',
//         background: '#fff',
//     };

//     const dishesGridStyle = {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(2, 1fr)',
//         gap: '6px',
//         maxHeight: '160px',
//         overflowY: 'auto',
//         padding: '4px 2px',
//     };

//     const dishCheckboxStyle = {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         padding: '6px 10px',
//         background: '#F9FAFB',
//         border: '1px solid #F3F4F6',
//         borderRadius: '6px',
//         cursor: 'pointer',
//         fontSize: '13px',
//         transition: 'all 0.2s ease',
//     };

//     const dishPriceStyle = {
//         fontSize: '11px',
//         color: '#6B7280',
//         marginLeft: 'auto',
//         fontWeight: 500,
//     };

//     const noDishesStyle = {
//         color: '#9CA3AF',
//         fontSize: '13px',
//         padding: '8px 0',
//     };

//     const formActionStyle = {
//         display: 'flex',
//         gap: '12px',
//         justifyContent: 'space-between',
//         paddingTop: '16px',

//     };

//     const cancelButtonStyle = {
//         padding: '10px 24px',
//         background: '#F3F4F6',
//         color: '#4B5563',
//         border: 'none',
//         borderRadius: '8px',
//         fontSize: '14px',
//         fontWeight: 500,
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//     };

//     const submitButtonStyle = {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         padding: '10px 28px',
//         background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//         color: '#fff',
//         border: 'none',
//         borderRadius: '8px',
//         fontSize: '14px',
//         fontWeight: 600,
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//         boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
//     };

//     return (
//         <div style={modalOverlayStyle} onClick={() => setShowModal(false)}>
//             <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
//                 <div style={modalHeaderStyle}>
//                     <div style={modalHeaderLeftStyle}>
//                         <div style={modalHeaderIconStyle}>
//                             {isEdit ? <FaEdit size={18} /> : <FaPlus size={18} />}
//                         </div>
//                         <h3 style={modalTitleStyle}>{title}</h3>
//                     </div>
//                     <button onClick={() => setShowModal(false)} style={modalCloseStyle}>
//                         <FaTimes />
//                     </button>
//                 </div>

//                 <form onSubmit={handleSubmit} style={modalBodyStyle}>
//                     {/* Source */}
//                     <div style={formRowStyle}>
//                         <div style={formGroupStyle}>
//                             <label style={labelStyle}>Source <span style={{ color: '#EF4444' }}>*</span></label>
//                             <select
//                                 name="source"
//                                 value={formData.source || 'APP'}
//                                 onChange={handleInputChange}
//                                 style={selectStyle}
//                                 required
//                             >
//                                 {ENUMS.source.map(s => (
//                                     <option key={s} value={s}>{s.replace('_', ' ')}</option>
//                                 ))}
//                             </select>
//                         </div>
//                         <div style={formGroupStyle}>
//                             <label style={labelStyle}>Source By</label>
//                             <input
//                                 name="sourceBy"
//                                 value={formData.sourceBy || ''}
//                                 onChange={handleInputChange}
//                                 style={inputStyle}
//                                 placeholder="Reference"
//                             />
//                         </div>
//                     </div>

//                     {/* Customer Details */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaUser size={15} />
//                             <span>Customer Details</span>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Full Name <span style={{ color: '#EF4444' }}>*</span></label>
//                                 <input
//                                     name="fullName"
//                                     value={formData.fullName || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="John Doe"
//                                     required
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Email <span style={{ color: '#EF4444' }}>*</span></label>
//                                 <input
//                                     name="email"
//                                     type="email"
//                                     value={formData.email || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="john@example.com"
//                                     required
//                                 />
//                             </div>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Phone Number <span style={{ color: '#EF4444' }}>*</span></label>
//                                 <input
//                                     name="phoneNumber"
//                                     value={formData.phoneNumber || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="+91 98765 43210"
//                                     required
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Company Name</label>
//                                 <input
//                                     name="companyName"
//                                     value={formData.companyName || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="Company name"
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Event Details */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaCalendarAlt size={15} />
//                             <span>Event Details</span>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Event <span style={{ color: '#EF4444' }}>*</span></label>
//                                 <select
//                                     name="event"
//                                     value={formData.event || 'EVENT'}
//                                     onChange={handleInputChange}
//                                     style={selectStyle}
//                                     required
//                                 >
//                                     {ENUMS.event.map(e => (
//                                         <option key={e} value={e}>{e}</option>
//                                     ))}
//                                 </select>
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Event Type <span style={{ color: '#EF4444' }}>*</span></label>
//                                 <select
//                                     name="eventType"
//                                     value={formData.eventType || (formData.event === 'DAILY' ? 'DAILY' : 'WEDDING')}
//                                     onChange={handleInputChange}
//                                     style={selectStyle}
//                                     required
//                                 >
//                                     {formData.event === 'DAILY' ? (
//                                         ['DAILY', 'WEEKLY', 'MONTHLY', 'CORPORATE', 'OTHER'].map(e => (
//                                             <option key={e} value={e}>{e}</option>
//                                         ))
//                                     ) : (
//                                         ENUMS.eventType.filter(e => !['DAILY', 'WEEKLY', 'MONTHLY', 'CORPORATE'].includes(e)).map(e => (
//                                             <option key={e} value={e}>{e}</option>
//                                         ))
//                                     )}
//                                 </select>
//                             </div>
//                         </div>

//                         {/* Date/Time Fields - Based on Event Type */}
//                         {formData.event === 'EVENT' ? (
//                             <div style={formRowStyle}>
//                                 <div style={formGroupStyle}>
//                                     <label style={labelStyle}>Event Date <span style={{ color: '#EF4444' }}>*</span></label>
//                                     <input
//                                         name="eventDate"
//                                         type="date"
//                                         value={formData.eventDate || ''}
//                                         onChange={handleInputChange}
//                                         style={inputStyle}
//                                         min={getMinDate()}
//                                         max={getMaxDate()}
//                                         required
//                                     />
//                                 </div>
//                                 <div style={formGroupStyle}>
//                                     <label style={labelStyle}>Event Time</label>
//                                     <input
//                                         name="eventTime"
//                                         type="time"
//                                         value={formData.eventTime || ''}
//                                         onChange={handleInputChange}
//                                         style={inputStyle}
//                                     />
//                                 </div>
//                             </div>
//                         ) : (
//                             <div style={formRowStyle}>
//                                 <div style={formGroupStyle}>
//                                     <label style={labelStyle}>From Date <span style={{ color: '#EF4444' }}>*</span></label>
//                                     <input
//                                         name="fromDate"
//                                         type="date"
//                                         value={formData.fromDate || ''}
//                                         onChange={handleInputChange}
//                                         style={inputStyle}
//                                         min={getMinDate()}
//                                         max={getMaxDate()}
//                                         required
//                                     />
//                                 </div>
//                                 <div style={formGroupStyle}>
//                                     <label style={labelStyle}>To Date <span style={{ color: '#EF4444' }}>*</span></label>
//                                     <input
//                                         name="toDate"
//                                         type="date"
//                                         value={formData.toDate || ''}
//                                         onChange={handleInputChange}
//                                         style={inputStyle}
//                                         min={getMinDate()}
//                                         max={getMaxDate()}
//                                         required
//                                     />
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                     {/* Venue Details */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaMapMarkerAlt size={15} />
//                             <span>Venue Details</span>
//                         </div>
//                         <div style={formGroupStyle}>
//                             <label style={labelStyle}>Full Address <span style={{ color: '#EF4444' }}>*</span></label>
//                             <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
//                                 <textarea
//                                     name="fullAddress"
//                                     value={formData.fullAddress || ''}
//                                     onChange={handleInputChange}
//                                     style={{ ...textareaStyle, flex: 1 }}
//                                     rows="2"
//                                     placeholder="123 Main St, City"
//                                     required
//                                 />
//                                 <button
//                                     type="button"
//                                     onClick={() => {
//                                         if (typeof setShowMapPicker === 'function' && typeof setMapPickerFor === 'function') {
//                                             setMapPickerFor(isEdit ? 'edit' : 'create');
//                                             setShowMapPicker(true);
//                                         }
//                                     }}
//                                     style={{
//                                         padding: '10px 14px',
//                                         background: '#e66d33',
//                                         color: '#fff',
//                                         border: 'none',
//                                         borderRadius: '8px',
//                                         cursor: 'pointer',
//                                         fontSize: '20px',
//                                         minHeight: '56px',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center',
//                                         transition: 'all 0.2s ease',
//                                         flexShrink: 0,
//                                     }}
//                                     title="Select location on map"
//                                     onMouseEnter={(e) => e.currentTarget.style.background = '#d45f2a'}
//                                     onMouseLeave={(e) => e.currentTarget.style.background = '#e66d33'}
//                                 >
//                                     <FaMapMarkerAlt />
//                                 </button>
//                             </div>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>City <span style={{ color: '#EF4444' }}>*</span></label>
//                                 <input
//                                     name="city"
//                                     value={formData.city || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="Mumbai"
//                                     required
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>State <span style={{ color: '#EF4444' }}>*</span></label>
//                                 <input
//                                     name="state"
//                                     value={formData.state || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="Maharashtra"
//                                     required
//                                 />
//                             </div>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Country</label>
//                                 <input
//                                     name="country"
//                                     value={formData.country || 'India'}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Pincode <span style={{ color: '#EF4444' }}>*</span></label>
//                                 <input
//                                     name="pincode"
//                                     type="number"
//                                     value={formData.pincode || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="400001"
//                                     required
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Plate Count & Budget */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaUtensils size={15} />
//                             <span>Plate Count & Budget</span>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Veg Plates</label>
//                                 <input
//                                     name="vegPlates"
//                                     type="number"
//                                     value={formData.vegPlates || 0}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     min="0"
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Non-Veg Plates</label>
//                                 <input
//                                     name="nonVegPlates"
//                                     type="number"
//                                     value={formData.nonVegPlates || 0}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     min="0"
//                                 />
//                             </div>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Mixed Plates</label>
//                                 <input
//                                     name="mixedPlates"
//                                     type="number"
//                                     value={formData.mixedPlates || 0}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     min="0"
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Budget (₹)</label>
//                                 <input
//                                     name="budget"
//                                     type="number"
//                                     value={formData.budget || 0}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     min="0"
//                                     placeholder="0"
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Add-ons Section */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaCheckCircle size={15} />
//                             <span>Add-ons</span>
//                         </div>
//                         <div style={addonsGridStyle}>
//                             {addOns.map((addon, index) => (
//                                 <div key={index} style={addonCardStyle}>
//                                     <label style={checkboxLabelStyle}>
//                                         <input
//                                             type="checkbox"
//                                             checked={addon.selected}
//                                             onChange={() => handleAddOnToggle(index)}
//                                             style={checkboxStyle}
//                                         />
//                                         <span style={{ fontWeight: 500, fontSize: '13px' }}>{addon.label}</span>
//                                     </label>
//                                     {addon.selected && (
//                                         <input
//                                             type="number"
//                                             value={addon.quantity}
//                                             onChange={(e) => handleAddOnQuantity(index, e.target.value)}
//                                             style={addonQuantityStyle}
//                                             min="1"
//                                             placeholder="Qty"
//                                         />
//                                     )}
//                                 </div>
//                             ))}
//                         </div>
//                     </div>

//                     {/* Dishes Section */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaUtensils size={15} />
//                             <span>Select Dishes</span>
//                         </div>
//                         <div style={dishesGridStyle}>
//                             {availableDishes.length === 0 ? (
//                                 <div style={noDishesStyle}>No dishes available</div>
//                             ) : (
//                                 availableDishes.map(dish => (
//                                     <label key={dish.dishId} style={dishCheckboxStyle}>
//                                         <input
//                                             type="checkbox"
//                                             checked={selectedDishIds.includes(dish.dishId)}
//                                             onChange={() => handleDishSelect(dish.dishId)}
//                                             style={checkboxStyle}
//                                         />
//                                         <span style={{ fontWeight: 500 }}>{dish.dishName}</span>
//                                         <span style={dishPriceStyle}>₹{dish.effectivePrice || dish.dishPrice}</span>
//                                     </label>
//                                 ))
//                             )}
//                         </div>
//                     </div>

//                     {/* Additional Requests */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaEdit size={15} />
//                             <span>Additional Requests</span>
//                         </div>
//                         <textarea
//                             name="additionalRequests"
//                             value={formData.additionalRequests || ''}
//                             onChange={handleInputChange}
//                             style={textareaStyle}
//                             rows="2"
//                             placeholder="Any special requests or requirements..."
//                         />
//                     </div>

//                     {/* GST Requirement */}
//                     <div style={formGroupStyle}>
//                         <label style={labelStyle}>GST Requirement</label>
//                         <input
//                             name="gstRequirement"
//                             value={formData.gstRequirement || ''}
//                             onChange={handleInputChange}
//                             style={inputStyle}
//                             placeholder="GST number if applicable"
//                         />
//                     </div>

//                     {/* Form Actions */}
//                     <div style={formActionStyle}>
//                         <button
//                             type="button"
//                             onClick={() => { resetForm(); setShowModal(false); }}
//                             style={cancelButtonStyle}
//                         >
//                             Cancel
//                         </button>
//                         <button type="submit" style={submitButtonStyle} disabled={submitting}>
//                             {submitting ? (
//                                 <>
//                                     <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
//                                     {isEdit ? 'Updating...' : 'Creating...'}
//                                 </>
//                             ) : (
//                                 <>
//                                     {isEdit ? <FaEdit size={14} /> : <FaPlus size={14} />}
//                                     {submitLabel}
//                                 </>
//                             )}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// // ─── Styles ──────────────────────────────────────────────────────
// // (Same styles as SalesEnquiry with some modifications)

// const containerStyle = {
//     height:"65vh",
//     scrollbarWidth:"thin",
// };

// const headerStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '24px',
//     flexWrap: 'wrap',
//     gap: '16px',
// };

// const headerLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
// };

// const headerIconStyle = {
//     width: '44px',
//     height: '44px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     borderRadius: '12px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     color: '#fff',
// };

// const titleStyle = {
//     fontSize: '24px',
//     fontWeight: 700,
//     color: '#111827',
//     margin: 0,
//     letterSpacing: '-0.5px',
// };

// const subtitleStyle = {
//     fontSize: '14px',
//     color: '#6B7280',
//     margin: '4px 0 0 0',
// };

// const createButtonStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 24px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '10px',
//     fontWeight: 600,
//     fontSize: '14px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
// };

// const statsContainerStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(5, 1fr)',
//     gap: '16px',
//     marginBottom: '16px',
// };

// const statCardStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
//     background: '#fff',
//     padding: '18px 20px',
//     borderRadius: '12px',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//     border: '1px solid #E5E7EB',
//     transition: 'all 0.2s ease',
// };

// const statIconWrapperStyle = {
//     width: '44px',
//     height: '44px',
//     borderRadius: '10px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
// };

// const statNumberStyle = {
//     fontSize: '22px',
//     fontWeight: 700,
//     color: '#111827',
//     lineHeight: 1.2,
// };

// const statLabelStyle = {
//     fontSize: '13px',
//     color: '#6B7280',
//     fontWeight: 500,
// };

// const searchFilterContainerStyle = {
//     display: 'flex',
//     gap: '12px',
//     marginBottom: '16px',
//     flexWrap: 'wrap',
//     alignItems: 'center',
// };

// const searchContainerStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     flex: 1,
//     minWidth: '200px',
//     background: '#fff',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     padding: '0 16px',
//     transition: 'all 0.2s ease',
// };

// const searchIconStyle = {
//     color: '#9CA3AF',
//     marginRight: '12px',
// };

// const searchInputStyle = {
//     flex: 1,
//     padding: '11px 0',
//     border: 'none',
//     outline: 'none',
//     fontSize: '14px',
//     background: 'transparent',
//     color: '#111827',
// };

// const dateFilterContainerStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     background: '#fff',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     padding: '4px 14px',
//     flexWrap: 'wrap',
// };

// const dateInputStyle = {
//     padding: '8px 8px',
//     border: 'none',
//     outline: 'none',
//     fontSize: '13px',
//     background: 'transparent',
//     color: '#111827',
//     width: '120px',
// };

// const dateSeparatorStyle = {
//     color: '#9CA3AF',
//     fontSize: '13px',
// };

// const clearButtonStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '4px',
//     padding: '4px 12px',
//     background: '#FEE2E2',
//     color: '#DC2626',
//     border: 'none',
//     borderRadius: '6px',
//     fontSize: '12px',
//     cursor: 'pointer',
//     fontWeight: 500,
//     transition: 'all 0.2s ease',
// };

// const filterIconStyle = {
//     color: '#6B7280',
//     fontSize: '13px',
// };

// const tableCardStyle = {
//     background: '#fff',
//     borderRadius: '12px',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//     overflow: 'hidden',
//     border: '1px solid #E5E7EB',
// };

// const tableWrapperStyle = {
//     overflowX: 'auto',
//     padding: '0',
//     maxHeight: '50vh',
//     scrollbarWidth: 'thin',
// };

// const tableStyle = {
//     width: '100%',
//     borderCollapse: 'collapse',
//     minWidth: '1100px',
// };

// const thStyle = {
//     padding: '12px 16px',
//     fontSize: '12px',
//     fontWeight: 600,
//     color: '#6B7280',
//     textTransform: 'uppercase',
//     letterSpacing: '0.5px',
//     background: '#F9FAFB',
//     borderBottom: '1px solid #E5E7EB',
// };

// const tdStyle = {
//     padding: '12px 16px',
//     fontSize: '13px',
//     color: '#111827',
//     borderBottom: '1px solid #F3F4F6',
// };

// const tableRowStyle = {
//     transition: 'background 0.15s ease',
//     cursor: 'default',
// };

// const customerCellStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
// };

// const avatarStyle = {
//     width: '32px',
//     height: '32px',
//     borderRadius: '50%',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     color: '#fff',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '13px',
//     fontWeight: 600,
//     flexShrink: 0,
// };

// const sourceBadgeStyle = {
//     display: 'inline-block',
//     padding: '2px 10px',
//     background: '#F3F4F6',
//     borderRadius: '6px',
//     fontSize: '12px',
//     fontWeight: 500,
//     color: '#4B5563',
// };

// const eventBadgeStyle = {
//     display: 'inline-block',
//     padding: '2px 10px',
//     background: '#F3F4F6',
//     borderRadius: '6px',
//     fontSize: '12px',
//     fontWeight: 500,
//     color: '#4B5563',
// };

// const cityBadgeStyle = {
//     display: 'inline-block',
//     padding: '2px 10px',
//     background: '#EEF2FF',
//     borderRadius: '6px',
//     fontSize: '12px',
//     fontWeight: 500,
//     color: '#4F46E5',
// };

// const emptyStateStyle = {
//     padding: '60px 20px',
//     textAlign: 'center',
//     borderBottom: 'none',
// };

// const emptyStateContentStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '8px',
// };

// const loadingStyle = {
//     padding: '60px 20px',
//     textAlign: 'center',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '12px',
//     color: '#6B7280',
// };

// const actionGroupStyle = {
//     display: 'flex',
//     gap: '6px',
//     justifyContent: 'center',
//     flexWrap: 'wrap',
// };

// const viewButtonStyle = {
//     padding: '6px 10px',
//     background: '#60A5FA',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '13px',
// };

// const editButtonStyle = {
//     padding: '6px 10px',
//     background: '#34D399',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '13px',
// };

// const deleteButtonStyle = {
//     padding: '6px 10px',
//     background: '#F87171',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '13px',
// };

// // ─── Modal Styles ──────────────────────────────────────────────
// // (Same as SalesEnquiry - reuse exact same modal styles)

// const modalOverlayStyle = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'rgba(0,0,0,0.5)',
//     backdropFilter: 'blur(4px)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 9999,
//     padding: '20px',
//     animation: 'fadeIn 0.25s ease',
// };

// const modalStyle = {
//     background: '#fff',
//     borderRadius: '16px',
//     width: '100%',
//     maxWidth: '720px',
//     maxHeight: '90vh',
//     scrollbarWidth: "none",
//     overflow: 'auto',
//     boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
//     animation: 'slideUp 0.3s ease',
// };

// const modalHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '20px 24px',
//     borderBottom: '1px solid #F3F4F6',
//     position: 'sticky',
//     top: 0,
//     background: '#fff',
//     zIndex: 1,
// };

// const modalHeaderLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
// };

// const modalHeaderIconStyle = {
//     width: '36px',
//     height: '36px',
//     borderRadius: '10px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     color: '#fff',
// };

// const modalTitleStyle = {
//     margin: 0,
//     fontSize: '18px',
//     fontWeight: 700,
//     color: '#111827',
// };

// const modalCloseStyle = {
//     background: '#F3F4F6',
//     border: 'none',
//     fontSize: '16px',
//     cursor: 'pointer',
//     color: '#6B7280',
//     padding: '6px 10px',
//     borderRadius: '8px',
//     transition: 'all 0.2s ease',
// };

// const modalBodyStyle = {
//     padding: '24px',
// };

// const formActionStyle = {
//     display: 'flex',
//     gap: '12px',
//     justifyContent: 'flex-end',
//     marginTop: '8px',
//     paddingTop: '16px',
//     borderTop: '1px solid #F3F4F6',
// };

// const cancelButtonStyle = {
//     padding: '10px 24px',
//     background: '#F3F4F6',
//     color: '#4B5563',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 500,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// const submitButtonStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 28px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 600,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
// };

// // ─── View Styles ────────────────────────────────────────────────

// const viewSectionStyle = {
//     border: '1px solid #F3F4F6',
//     borderRadius: '8px',
//     padding: '14px 16px',
//     marginBottom: '12px',
// };

// const viewSectionTitleStyle = {
//     margin: '0 0 10px 0',
//     fontSize: '14px',
//     fontWeight: 600,
//     color: '#1E293B',
// };

// const viewGridStyle = {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr',
//     gap: '8px 16px',
// };
// // ─── Custom Date Modal Styles ──────────────────────────────────

// const customDateModalOverlay = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'rgba(0,0,0,0.5)',
//     backdropFilter: 'blur(4px)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 10000,
//     padding: '20px',
//     animation: 'fadeIn 0.25s ease',
// };

// const customDateModalStyle = {
//     background: '#fff',
//     borderRadius: '16px',
//     width: '100%',
//     maxWidth: '420px',
//     boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
//     animation: 'slideUp 0.3s ease',
// };

// const customDateModalHeader = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '20px 24px',
//     borderBottom: '1px solid #F3F4F6',
// };

// const customDateModalTitle = {
//     margin: 0,
//     fontSize: '18px',
//     fontWeight: 700,
//     color: '#111827',
// };

// const customDateModalClose = {
//     background: 'none',
//     border: 'none',
//     fontSize: '20px',
//     cursor: 'pointer',
//     color: '#6B7280',
//     padding: '4px 8px',
//     transition: 'color 0.2s ease',
// };

// const customDateModalBody = {
//     padding: '24px',
// };

// const customDateModalInputGroup = {
//     marginBottom: '16px',
// };

// const customDateModalLabel = {
//     display: 'block',
//     fontSize: '13px',
//     fontWeight: 500,
//     color: '#374151',
//     marginBottom: '6px',
// };

// const customDateModalInput = {
//     width: '100%',
//     padding: '10px 12px',
//     border: '1px solid #E5E7EB',
//     borderRadius: '8px',
//     fontSize: '14px',
//     outline: 'none',
//     transition: 'all 0.2s ease',
//     background: '#fff',
//     color: '#111827',
//     boxSizing: 'border-box',
// };

// const customDateModalFooter = {
//     display: 'flex',
//     gap: '10px',
//     justifyContent: 'flex-end',
//     padding: '16px 24px',
//     borderTop: '1px solid #F3F4F6',
// };

// const customDateModalCancel = {
//     padding: '8px 20px',
//     background: '#F3F4F6',
//     color: '#4B5563',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 500,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// const customDateModalApply = {
//     padding: '8px 24px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 600,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     boxShadow: '0 4px 12px rgba(230, 109, 51, 0.3)',
// };


// const filterSelectStyle = {
//     padding: '7px 4px',
//     border: 'none',
//     outline: 'none',
//     fontSize: '14px',
//     background: 'transparent',
//     cursor: 'pointer',
//     color: '#111827',
//     appearance: 'none',
//     paddingRight: '4px',
// };
// export default ManagerEnquiry;




import React, { useState, useEffect } from 'react';
import {
    FaPlus, FaEye, FaEdit, FaTrash, FaTimes,
    FaUser, FaEnvelope, FaPhone, FaBuilding,
    FaMapMarkerAlt, FaCalendarAlt, FaUtensils,
    FaCheckCircle, FaSearch, FaFilter, FaClock,
    FaSpinner, FaSync, FaChevronDown, FaUsers,
    FaClipboardList, FaChartBar, FaPaperPlane,
    FaUpload, FaDownload, FaFileExcel
} from 'react-icons/fa';
import {
    getAllEnquiries,
    createEnquiry,
    updateEnquiry,
    deleteEnquiry,
    ENUMS,
    addItemsToEnquiry
} from '../../../Servicefile/salesService';
import GoogleMapPicker from '../../../GoogleMapPicker';
import { getMenu } from '../../../Servicefile/Menuapiservice';

const ManagerEnquiry = () => {
    // ============================================
    // STATE
    // ============================================
    const [enquiries, setEnquiries] = useState([]);
    const [dishes, setDishes] = useState([]); // ✅ New state for dishes
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const ADMIN_ID = localStorage.getItem("userId");

    // Date filter states
    const [dateFilter, setDateFilter] = useState('all');
    const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');
    const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
    const [showCustomDateModal, setShowCustomDateModal] = useState(false);

    // Modal states
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);

    // Selected enquiry
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);
    const [editingEnquiry, setEditingEnquiry] = useState(null);

    // Stats
    const [stats, setStats] = useState({
        total: 0,
        approved: 0,
        inProgress: 0,
        completed: 0,
        rejected: 0
    });

    // Date filter helper functions
    const getDateRange = (filterType) => {
        const today = new Date();
        const start = new Date();
        const end = new Date();

        switch (filterType) {
            case 'today':
                start.setHours(0, 0, 0, 0);
                end.setHours(23, 59, 59, 999);
                break;
            case 'yesterday':
                start.setDate(today.getDate() - 1);
                start.setHours(0, 0, 0, 0);
                end.setDate(today.getDate() - 1);
                end.setHours(23, 59, 59, 999);
                break;
            case 'week':
                const day = today.getDay();
                start.setDate(today.getDate() - day);
                start.setHours(0, 0, 0, 0);
                end.setDate(today.getDate() + (6 - day));
                end.setHours(23, 59, 59, 999);
                break;
            case 'month':
                start.setDate(1);
                start.setHours(0, 0, 0, 0);
                end.setHours(23, 59, 59, 999);
                break;
            case 'custom':
                if (customStartDate && customEndDate) {
                    return { from: new Date(customStartDate), to: new Date(customEndDate) };
                }
                return null;
            default:
                return null;
        }
        return { from: start, to: end };
    };

    const applyDateFilter = (enquiriesList) => {
        if (dateFilter === 'all') return enquiriesList;

        const range = getDateRange(dateFilter);
        if (!range) return enquiriesList;

        return enquiriesList.filter(enquiry => {
            const dateStr = enquiry.createdAt || enquiry.eventDate;
            if (!dateStr) return false;
            const enquiryDate = new Date(dateStr);
            return enquiryDate >= range.from && enquiryDate <= range.to;
        });
    };

    const getDateFilterLabel = () => {
        switch (dateFilter) {
            case 'all': return 'All Dates';
            case 'today': return 'Today';
            case 'yesterday': return 'Yesterday';
            case 'week': return 'This Week';
            case 'month': return 'This Month';
            case 'custom': return 'Custom Range';
            default: return 'All Dates';
        }
    };

    // ============================================
    // FORM DATA
    // ============================================
    const [formData, setFormData] = useState({
        source: 'APP',
        sourceBy: '',
        fullName: '',
        email: '',
        phoneNumber: '',
        event: 'EVENT',
        eventType: 'WEDDING',
        eventDate: '',
        eventTime: '',
        fromDate: '',
        toDate: '',
        fullAddress: '',
        city: '',
        state: '',
        country: 'India',
        companyName: '',
        vegPlates: '',
        nonVegPlates: '',
        mixedPlates: '',
        additionalRequests: '',
        adminPermision: false,
        leadStatus: 'PENDING',
        budget: '',
        latitude: 0,
        longitude: 0,
        pincode: '',
        gstRequirement: '',
        dishId: [],
        addOns: []
    });

    const addOnOptions = [
        { addOnType: 'SERVICE_BOYS', label: 'Service Boys', selected: false, quantity: 0 },
        { addOnType: 'PAPER_PLATES', label: 'Paper Plates', selected: false, quantity: 0 },
        { addOnType: 'WATER_BOTTLES', label: 'Water Bottles', selected: false, quantity: 0 },
        { addOnType: 'DISPOSABLE_CUPS', label: 'Disposable Cups', selected: false, quantity: 0 },
        { addOnType: 'TISSUE_PAPER', label: 'Tissue Paper', selected: false, quantity: 0 }
    ];
    const [addOns, setAddOns] = useState(addOnOptions);
    const [selectedDishIds, setSelectedDishIds] = useState([]);
    const [showMapPicker, setShowMapPicker] = useState(false);
    const [mapPickerFor, setMapPickerFor] = useState('create');

    // ============================================
    // API CALLS
    // ============================================
    const fetchEnquiries = async () => {
        setLoading(true);
        try {
            const data = await getAllEnquiries();
            const sortedData = (data || []).sort((a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return dateB - dateA;
            });
            setEnquiries(sortedData);
            calculateStats(sortedData);
        } catch (error) {
            console.error('Error fetching enquiries:', error);
            alert('Failed to fetch enquiries');
        } finally {
            setLoading(false);
        }
    };

    // ✅ New function to fetch dishes
    const fetchDishes = async () => {
        try {
            const data = await getMenu();
            
            if (data && Array.isArray(data)) {
                // Filter only dishes (parentId !== 0)
                const dishItems = data.filter(item => 
                    item.parentId !== 0 && 
                    item.parentId !== null && 
                    item.parentId !== undefined
                );
                
                const formattedDishes = dishItems.map(item => ({
                    dishId: item.dishId,
                    dishName: item.dishName,
                    dishPrice: item.dishPrice,
                    effectivePrice: item.effectivePrice || item.dishPrice,
                    parentId: item.parentId,
                    dishType: item.dishType,
                    available: item.available
                }));
                
                setDishes(formattedDishes);
            }
        } catch (error) {
            console.error('Error fetching dishes:', error);
        }
    };

    const calculateStats = (data) => {
        const total = data.length;
        const approved = data.filter(e => e.leadStatus === 'APPROVED').length;
        const inProgress = data.filter(e =>
            e.leadStatus === 'PAYMENT_RECEIVED' ||
            e.leadStatus === 'ASSIGNED' ||
            e.leadStatus === 'ACCEPT' ||
            e.leadStatus === 'ACCEPTED'
        ).length;
        const completed = data.filter(e => e.leadStatus === 'CLOSED').length;
        const rejected = data.filter(e => e.leadStatus === 'REJECTED').length;

        setStats({ total, approved, inProgress, completed, rejected });
    };

    // ============================================
    // HANDLERS
    // ============================================
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleAddOnToggle = (index) => {
        const updated = [...addOns];
        updated[index].selected = !updated[index].selected;
        if (!updated[index].selected) {
            updated[index].quantity = 0;
        }
        setAddOns(updated);
    };

    const handleAddOnQuantity = (index, value) => {
        const updated = [...addOns];
        updated[index].quantity = parseInt(value) || 0;
        setAddOns(updated);
    };

    const handleDishSelect = (dishId) => {
        setSelectedDishIds(prev => {
            if (prev.includes(dishId)) {
                return prev.filter(id => id !== dishId);
            } else {
                return [...prev, dishId];
            }
        });
    };

    const resetForm = () => {
        setFormData({
            source: 'APP',
            sourceBy: '',
            fullName: '',
            email: '',
            phoneNumber: '',
            event: 'EVENT',
            eventType: 'WEDDING',
            eventDate: '',
            eventTime: '',
            fromDate: '',
            toDate: '',
            fullAddress: '',
            city: '',
            state: '',
            country: 'India',
            companyName: '',
            vegPlates: '',
            nonVegPlates: '',
            mixedPlates: '',
            additionalRequests: '',
            adminPermision: false,
            leadStatus: 'PENDING',
            budget: '',
            latitude: 0,
            longitude: 0,
            pincode: '',
            gstRequirement: '',
            dishId: [],
            addOns: []
        });
        setAddOns(addOnOptions);
        setSelectedDishIds([]);
        setEditingEnquiry(null);
    };

    // ✅ Updated handleLocationSelect to properly set pincode
    const handleLocationSelect = (locationData) => {
        
        setFormData(prev => ({
            ...prev,
            latitude: locationData.latitude,
            longitude: locationData.longitude,
            fullAddress: locationData.address,
            city: locationData.city || prev.city,
            state: locationData.state || prev.state,
            pincode: locationData.pincode || prev.pincode,
            country: locationData.country || prev.country,
        }));
    };

    const formatDateForAPI = (dateStr) => {
        if (!dateStr) return '';
        const parts = dateStr.split('-');
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    };

    const getMinDate = () => {
        const date = new Date();
        date.setDate(date.getDate() + 2);
        return date.toISOString().split('T')[0];
    };

    const getMaxDate = () => {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 3);
        return date.toISOString().split('T')[0];
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.fullName) {
            alert('Please enter full name');
            return;
        }
        if (!formData.email) {
            alert('Please enter email');
            return;
        }
        if (!formData.phoneNumber) {
            alert('Please enter phone number');
            return;
        }

        if (formData.event === 'EVENT') {
            if (!formData.eventDate) {
                alert('Please select event date');
                return;
            }
        } else if (formData.event === 'DAILY') {
            if (!formData.fromDate || !formData.toDate) {
                alert('Please select from and to dates');
                return;
            }
        }

        const selectedAddOns = addOns
            .filter(a => a.selected)
            .map(a => ({
                addOnType: a.addOnType,
                quantity: a.quantity || 1,
                selected: true
            }));

        const requestBody = {
            ...formData,
            eventDate: formData.eventDate ? formatDateForAPI(formData.eventDate) : '',
            fromDate: formData.fromDate ? formatDateForAPI(formData.fromDate) : '',
            toDate: formData.toDate ? formatDateForAPI(formData.toDate) : '',
            eventTime: formData.eventTime || '',
            addOns: selectedAddOns,
            dishId: selectedDishIds,
            pincode: parseInt(formData.pincode) || 0,
            budget: parseFloat(formData.budget) || 0,
            vegPlates: parseInt(formData.vegPlates) || 0,
            nonVegPlates: parseInt(formData.nonVegPlates) || 0,
            mixedPlates: parseInt(formData.mixedPlates) || 0
        };

        setSubmitting(true);
        try {
            await createEnquiry(requestBody);
            alert('Enquiry created successfully!');
            setShowCreateModal(false);
            resetForm();
            fetchEnquiries();
        } catch (error) {
            console.error('Error creating enquiry:', error);
            alert(error.response?.data?.message || 'Failed to create enquiry');
        } finally {
            setSubmitting(false);
        }
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();

        if (!formData.fullName) {
            alert('Please enter full name');
            return;
        }
        if (!formData.email) {
            alert('Please enter email');
            return;
        }
        if (!formData.phoneNumber) {
            alert('Please enter phone number');
            return;
        }

        const selectedAddOns = addOns
            .filter(a => a.selected)
            .map(a => ({
                addOnType: a.addOnType,
                quantity: a.quantity || 1,
                selected: true
            }));

        const requestBody = {
            source: formData.source || 'APP',
            sourceBy: formData.sourceBy || '',
            fullName: formData.fullName,
            email: formData.email,
            phoneNumber: formData.phoneNumber,
            event: formData.event || 'EVENT',
            eventType: formData.eventType || 'WEDDING',
            eventDate: formData.eventDate ? formatDateForAPI(formData.eventDate) : '',
            eventTime: formData.eventTime || '',
            fromDate: formData.fromDate ? formatDateForAPI(formData.fromDate) : '',
            toDate: formData.toDate ? formatDateForAPI(formData.toDate) : '',
            fullAddress: formData.fullAddress || '',
            city: formData.city || '',
            state: formData.state || '',
            country: formData.country || 'India',
            companyName: formData.companyName || '',
            vegPlates: parseInt(formData.vegPlates) || 0,
            nonVegPlates: parseInt(formData.nonVegPlates) || 0,
            mixedPlates: parseInt(formData.mixedPlates) || 0,
            additionalRequests: formData.additionalRequests || '',
            adminPermision: formData.adminPermision || false,
            leadStatus: formData.leadStatus || 'PENDING',
            budget: parseFloat(formData.budget) || 0,
            latitude: parseFloat(formData.latitude) || 0,
            longitude: parseFloat(formData.longitude) || 0,
            pincode: parseInt(formData.pincode) || 0,
            gstRequirement: formData.gstRequirement || '',
            addOns: selectedAddOns
        };

        setSubmitting(true);
        try {
            const enquiryId = editingEnquiry.id || editingEnquiry.enquiryId;
            await updateEnquiry(enquiryId, requestBody);

            if (selectedDishIds.length > 0) {
                await addItemsToEnquiry(enquiryId, selectedDishIds);
            }

            alert('Enquiry updated successfully!');
            setShowEditModal(false);
            resetForm();
            fetchEnquiries();
        } catch (error) {
            console.error('Error updating enquiry:', error);
            alert(error.response?.data?.message || 'Failed to update enquiry');
        } finally {
            setSubmitting(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this enquiry?')) return;

        try {
            await deleteEnquiry(id);
            alert('Enquiry deleted successfully!');
            fetchEnquiries();
        } catch (error) {
            console.error('Error deleting enquiry:', error);
            alert('Failed to delete enquiry');
        }
    };

    const handleEditClick = (enquiry) => {
        setEditingEnquiry(enquiry);
        setFormData({
            source: enquiry.source || 'APP',
            sourceBy: enquiry.sourceBy || '',
            fullName: enquiry.fullName || '',
            email: enquiry.email || '',
            phoneNumber: enquiry.phoneNumber || '',
            event: enquiry.event || 'EVENT',
            eventType: enquiry.eventType || 'WEDDING',
            eventDate: enquiry.eventDate || '',
            eventTime: enquiry.eventTime || '',
            fromDate: enquiry.fromDate || '',
            toDate: enquiry.toDate || '',
            fullAddress: enquiry.fullAddress || '',
            city: enquiry.city || '',
            state: enquiry.state || '',
            country: enquiry.country || 'India',
            companyName: enquiry.companyName || '',
            vegPlates: enquiry.vegPlates || 0,
            nonVegPlates: enquiry.nonVegPlates || 0,
            mixedPlates: enquiry.mixedPlates || 0,
            additionalRequests: enquiry.additionalRequests || '',
            adminPermision: enquiry.adminPermision || false,
            leadStatus: enquiry.leadStatus || 'PENDING',
            budget: enquiry.budget || 0,
            latitude: enquiry.latitude || 0,
            longitude: enquiry.longitude || 0,
            pincode: enquiry.pincode || '',
            gstRequirement: enquiry.gstRequirement || '',
            dishId: enquiry.dishId || [],
            addOns: enquiry.addOns || []
        });
        setSelectedDishIds(enquiry.dishId || []);

        if (enquiry.addOns && enquiry.addOns.length > 0) {
            const updatedAddOns = addOnOptions.map(option => {
                const existing = enquiry.addOns.find(a => a.addOnType === option.addOnType);
                return {
                    ...option,
                    selected: !!existing,
                    quantity: existing?.quantity || 0
                };
            });
            setAddOns(updatedAddOns);
        } else {
            setAddOns(addOnOptions);
        }

        setShowEditModal(true);
    };

    const handleViewClick = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setShowViewModal(true);
    };

    // ============================================
    // FILTERS
    // ============================================
    const filteredEnquiries = applyDateFilter(enquiries).filter(enquiry => {
        const matchesSearch =
            (enquiry.fullName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (enquiry.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (enquiry.companyName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (enquiry.city || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (enquiry.sourceBy || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (enquiry.source || '').toLowerCase().includes(searchTerm.toLowerCase());

        return matchesSearch;
    });

    const clearFilters = () => {
        setSearchTerm('');
        setStartDate('');
        setEndDate('');
    };

    const getStatusBadge = (status) => {
        const statusMap = {
            'PENDING': { bg: '#FEF3C7', color: '#92400E', label: 'Pending' },
            'APPROVED': { bg: '#D1FAE5', color: '#065F46', label: 'Approved' },
            'PAYMENT_RECEIVED': { bg: '#DBEAFE', color: '#1E40AF', label: 'Quoted' },
            'ASSIGNED': { bg: '#DBEAFE', color: '#1E40AF', label: 'Assigned' },
            'ACCEPT': { bg: '#DBEAFE', color: '#1E40AF', label: 'Accept' },
            'ACCEPTED': { bg: '#DBEAFE', color: '#1E40AF', label: 'Accepted' },
            'CLOSED': { bg: '#D1FAE5', color: '#065F46', label: 'Closed' },
            'REJECTED': { bg: '#FEE2E2', color: '#991B1B', label: 'Rejected' }
        };
        const statusInfo = statusMap[status] || statusMap['PENDING'];
        return (
            <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                padding: '4px 12px',
                borderRadius: '20px',
                fontSize: '11px',
                fontWeight: 600,
                background: statusInfo.bg,
                color: statusInfo.color
            }}>
                {statusInfo.label}
            </span>
        );
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch {
            return dateStr;
        }
    };

    // ============================================
    // EFFECTS
    // ============================================
    useEffect(() => {
        fetchEnquiries();
        fetchDishes(); // ✅ Fetch dishes
    }, []);

    // ============================================
    // RENDER
    // ============================================
    return (
        <div style={containerStyle}>
            {/* Header */}
            <div style={headerStyle}>
                <div style={headerLeftStyle}>
                    <div style={headerIconStyle}>
                        <FaUsers size={22} />
                    </div>
                    <div>
                        <h2 style={titleStyle}>Manager Enquiry</h2>
                        <p style={subtitleStyle}>Manage and track all your enquiries from various sources</p>
                    </div>
                </div>
                <button
                    onClick={() => { resetForm(); setShowCreateModal(true); }}
                    style={createButtonStyle}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                    <FaPlus size={14} />
                    New Enquiry
                </button>
            </div>

            {/* Stats Cards */}
            <div style={statsContainerStyle}>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#EEF2FF' }}>
                        <FaClipboardList style={{ color: '#4F46E5' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{stats.total}</div>
                        <div style={statLabelStyle}>Total</div>
                    </div>
                </div>

                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#D1FAE5' }}>
                        <FaCheckCircle style={{ color: '#059669' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{stats.approved}</div>
                        <div style={statLabelStyle}>Approved</div>
                    </div>
                </div>

                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#DBEAFE' }}>
                        <FaSync style={{ color: '#1E40AF' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{stats.inProgress}</div>
                        <div style={statLabelStyle}>In Progress</div>
                    </div>
                </div>

                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#D1FAE5' }}>
                        <FaCheckCircle style={{ color: '#059669' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{stats.completed}</div>
                        <div style={statLabelStyle}>Completed</div>
                    </div>
                </div>

                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#FEE2E2' }}>
                        <FaTimes style={{ color: '#DC2626' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{stats.rejected}</div>
                        <div style={statLabelStyle}>Rejected</div>
                    </div>
                </div>
            </div>

            {/* Search and Filter */}
            <div style={searchFilterContainerStyle}>
                <div style={searchContainerStyle}>
                    <FaSearch style={searchIconStyle} />
                    <input
                        type="text"
                        placeholder="Search by name, email, source, city..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={searchInputStyle}
                    />
                </div>

                <div style={dateFilterContainerStyle}>
                    <FaCalendarAlt style={filterIconStyle} />
                    <select
                        value={dateFilter}
                        onChange={(e) => {
                            const value = e.target.value;
                            setDateFilter(value);
                            if (value === 'custom') {
                                setShowCustomDateModal(true);
                            } else {
                                setShowCustomDatePicker(false);
                            }
                        }}
                        style={filterSelectStyle}
                    >
                        <option value="all" style={{ padding: "10px" }}>All Dates</option>
                        <option value="today" style={{ padding: "10px" }}>Today</option>
                        <option value="yesterday" style={{ padding: "10px" }}>Yesterday</option>
                        <option value="week" style={{ padding: "10px" }}>This Week</option>
                        <option value="month" style={{ padding: "10px" }}>This Month</option>
                        <option value="custom" style={{ padding: "10px", margin: "10px" }}>Custom Range</option>
                    </select>
                    <FaChevronDown style={{ color: '#9CA3AF', fontSize: '10px', marginLeft: '4px' }} />
                </div>

                {showCustomDateModal && (
                    <div style={customDateModalOverlay} onClick={() => setShowCustomDateModal(false)}>
                        <div style={customDateModalStyle} onClick={(e) => e.stopPropagation()}>
                            <div style={customDateModalHeader}>
                                <h3 style={customDateModalTitle}>Select Custom Date Range</h3>
                                <button
                                    onClick={() => setShowCustomDateModal(false)}
                                    style={customDateModalClose}
                                >
                                    <FaTimes />
                                </button>
                            </div>
                            <div style={customDateModalBody}>
                                <div style={customDateModalInputGroup}>
                                    <label style={customDateModalLabel}>From Date</label>
                                    <input
                                        type="date"
                                        value={customStartDate}
                                        onChange={(e) => setCustomStartDate(e.target.value)}
                                        style={customDateModalInput}
                                        max={customEndDate || undefined}
                                    />
                                </div>
                                <div style={customDateModalInputGroup}>
                                    <label style={customDateModalLabel}>To Date</label>
                                    <input
                                        type="date"
                                        value={customEndDate}
                                        onChange={(e) => setCustomEndDate(e.target.value)}
                                        style={customDateModalInput}
                                        min={customStartDate || undefined}
                                        max={new Date().toISOString().split('T')[0]}
                                    />
                                </div>
                            </div>
                            <div style={customDateModalFooter}>
                                <button
                                    onClick={() => {
                                        setShowCustomDateModal(false);
                                        setCustomStartDate('');
                                        setCustomEndDate('');
                                    }}
                                    style={customDateModalCancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        if (customStartDate && customEndDate) {
                                            setDateFilter('custom');
                                            setShowCustomDateModal(false);
                                            setShowCustomDatePicker(false);
                                        } else {
                                            alert('Please select both start and end dates');
                                        }
                                    }}
                                    style={customDateModalApply}
                                >
                                    Apply Range
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Table */}
            <div style={tableCardStyle}>
                {loading ? (
                    <div style={loadingStyle}>
                        <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={32} color="#4F46E5" />
                        <p>Loading enquiries...</p>
                    </div>
                ) : (
                    <div style={tableWrapperStyle}>
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={{ ...thStyle, width: '4%', textAlign: 'center' }}>#</th>
                                    <th style={{ ...thStyle, width: '4%', textAlign: 'center' }}>ID</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'left' }}>Customer</th>
                                    <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Source</th>
                                    <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Source By</th>
                                    <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Event</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Date</th>
                                    <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>City</th>
                                    <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Budget</th>
                                    <th style={{ ...thStyle, width: '10%', textAlign: 'center' }}>Status</th>
                                    <th style={{ ...thStyle, width: '26%', textAlign: 'center' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredEnquiries.length === 0 ? (
                                    <tr>
                                        <td colSpan="10" style={emptyStateStyle}>
                                            <div style={emptyStateContentStyle}>
                                                <FaUsers size={40} color="#D1D5DB" />
                                                <p>No enquiries found</p>
                                                <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
                                                    Try adjusting your search or filter
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    filteredEnquiries.map((enquiry, index) => (
                                        <tr key={enquiry.id || enquiry.enquiryId || index} style={tableRowStyle}>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 500, color: '#9CA3AF' }}>
                                                {index + 1}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 500, color: '#9CA3AF' }}>
                                                {enquiry.id}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'left' }}>
                                                <div style={customerCellStyle}>
                                                    <div style={avatarStyle}>
                                                        {(enquiry.fullName || '?')[0].toUpperCase()}
                                                    </div>
                                                    <div>
                                                        <div style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>
                                                            {enquiry.fullName || '-'}
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: '#6B7280' }}>
                                                            {enquiry.email || '-'}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <span style={sourceBadgeStyle}>
                                                    {enquiry.source || '-'}
                                                </span>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                {enquiry.sourceBy || '-'}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <span style={eventBadgeStyle}>
                                                    {enquiry.eventType || '-'}
                                                </span>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontSize: '12px', color: '#374151' }}>
                                                {enquiry.event === 'EVENT'
                                                    ? formatDate(enquiry.eventDate)
                                                    : `${formatDate(enquiry.fromDate)} - ${formatDate(enquiry.toDate)}`}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <span style={cityBadgeStyle}>
                                                    {enquiry.city || '-'}
                                                </span>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#059669' }}>
                                                ₹{Number(enquiry.budget || 0).toLocaleString()}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                {getStatusBadge(enquiry.leadStatus)}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <div style={actionGroupStyle}>
                                                    <button
                                                        style={viewButtonStyle}
                                                        title="View Details"
                                                        onClick={() => handleViewClick(enquiry)}
                                                    >
                                                        <FaEye size={13} />
                                                    </button>

                                                    {enquiry.leadStatus === 'PENDING' && (
                                                        <button
                                                            style={editButtonStyle}
                                                            title="Edit"
                                                            onClick={() => handleEditClick(enquiry)}
                                                        >
                                                            <FaEdit size={13} />
                                                        </button>
                                                    )}

                                                    {enquiry.leadStatus === 'PENDING' && (
                                                        <button
                                                            style={deleteButtonStyle}
                                                            title="Delete"
                                                            onClick={() => handleDelete(enquiry.id || enquiry.enquiryId)}
                                                        >
                                                            <FaTrash size={13} />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Create Enquiry Modal */}
            {showCreateModal && (
                <EnquiryModal
                    formData={formData}
                    setFormData={setFormData}
                    addOns={addOns}
                    setAddOns={setAddOns}
                    selectedDishIds={selectedDishIds}
                    setSelectedDishIds={setSelectedDishIds}
                    handleInputChange={handleInputChange}
                    handleAddOnToggle={handleAddOnToggle}
                    handleAddOnQuantity={handleAddOnQuantity}
                    handleDishSelect={handleDishSelect}
                    handleSubmit={handleSubmit}
                    resetForm={resetForm}
                    setShowModal={setShowCreateModal}
                    submitting={submitting}
                    getMinDate={getMinDate}
                    getMaxDate={getMaxDate}
                    ENUMS={ENUMS}
                    title="New Enquiry"
                    submitLabel="Create Enquiry"
                    showMapPicker={showMapPicker}
                    setShowMapPicker={setShowMapPicker}
                    setMapPickerFor={setMapPickerFor}
                    onLocationSelect={handleLocationSelect}
                    dishes={dishes} // ✅ Pass dishes
                />
            )}

            {/* Edit Enquiry Modal */}
            {showEditModal && editingEnquiry && (
                <EnquiryModal
                    formData={formData}
                    setFormData={setFormData}
                    addOns={addOns}
                    setAddOns={setAddOns}
                    selectedDishIds={selectedDishIds}
                    setSelectedDishIds={setSelectedDishIds}
                    handleInputChange={handleInputChange}
                    handleAddOnToggle={handleAddOnToggle}
                    handleAddOnQuantity={handleAddOnQuantity}
                    handleDishSelect={handleDishSelect}
                    handleSubmit={handleUpdateSubmit}
                    resetForm={resetForm}
                    setShowModal={setShowEditModal}
                    submitting={submitting}
                    getMinDate={getMinDate}
                    getMaxDate={getMaxDate}
                    ENUMS={ENUMS}
                    title="Edit Enquiry"
                    submitLabel="Update Enquiry"
                    isEdit={true}
                    showMapPicker={showMapPicker}
                    setShowMapPicker={setShowMapPicker}
                    setMapPickerFor={setMapPickerFor}
                    onLocationSelect={handleLocationSelect}
                    dishes={dishes} // ✅ Pass dishes
                />
            )}

            {/* View Enquiry Modal */}
            {showViewModal && selectedEnquiry && (
                <div style={modalOverlayStyle} onClick={() => setShowViewModal(false)}>
                    <div style={{ ...modalStyle, maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={modalHeaderIconStyle}>
                                    <FaEye size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>Enquiry Details</h3>
                            </div>
                            <button onClick={() => setShowViewModal(false)} style={modalCloseStyle}>
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            <div style={viewSectionStyle}>
                                <h4 style={viewSectionTitleStyle}>Contact Information</h4>
                                <div style={viewGridStyle}>
                                    <div><strong>Name:</strong> {selectedEnquiry.fullName || '-'}</div>
                                    <div><strong>Company:</strong> {selectedEnquiry.companyName || '-'}</div>
                                    <div><strong>Email:</strong> {selectedEnquiry.email || '-'}</div>
                                    <div><strong>Phone:</strong> {selectedEnquiry.phoneNumber || '-'}</div>
                                    <div><strong>City:</strong> {selectedEnquiry.city || '-'}</div>
                                    <div><strong>State:</strong> {selectedEnquiry.state || '-'}</div>
                                </div>
                            </div>

                            <div style={viewSectionStyle}>
                                <h4 style={viewSectionTitleStyle}>Enquiry Information</h4>
                                <div style={viewGridStyle}>
                                    <div><strong>Source:</strong> {selectedEnquiry.source || '-'}</div>
                                    <div><strong>Source By:</strong> {selectedEnquiry.sourceBy || '-'}</div>
                                    <div><strong>Event:</strong> {selectedEnquiry.eventType || '-'}</div>
                                    <div><strong>Event Date:</strong> {formatDate(selectedEnquiry.eventDate)}</div>
                                    <div><strong>Budget:</strong> ₹{Number(selectedEnquiry.budget || 0).toLocaleString()}</div>
                                    <div><strong>Status:</strong> {getStatusBadge(selectedEnquiry.leadStatus)}</div>
                                </div>
                            </div>

                            <div style={viewSectionStyle}>
                                <h4 style={viewSectionTitleStyle}>Additional Details</h4>
                                <div style={viewGridStyle}>
                                    <div><strong>Veg Plates:</strong> {selectedEnquiry.vegPlates || 0}</div>
                                    <div><strong>Non-Veg Plates:</strong> {selectedEnquiry.nonVegPlates || 0}</div>
                                    <div><strong>Mixed Plates:</strong> {selectedEnquiry.mixedPlates || 0}</div>
                                    <div style={{ gridColumn: '1 / -1' }}>
                                        <strong>Address:</strong> {selectedEnquiry.fullAddress || '-'}
                                    </div>
                                    <div style={{ gridColumn: '1 / -1' }}>
                                        <strong>Additional Requests:</strong> {selectedEnquiry.additionalRequests || '-'}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={formActionStyle}>
                            <button
                                onClick={() => setShowViewModal(false)}
                                style={cancelButtonStyle}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showMapPicker && (
                <GoogleMapPicker
                    onLocationSelect={handleLocationSelect}
                    onClose={() => setShowMapPicker(false)}
                    initialLat={formData.latitude || 17.3850}
                    initialLng={formData.longitude || 78.4867}
                    initialAddress={formData.fullAddress || ''}
                />
            )}

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

// ─── EnquiryModal Component ──────────────────────────────────────
const EnquiryModal = ({
    formData,
    setFormData,
    addOns,
    setAddOns,
    selectedDishIds,
    setSelectedDishIds,
    handleInputChange,
    handleAddOnToggle,
    handleAddOnQuantity,
    handleDishSelect,
    handleSubmit,
    resetForm,
    setShowModal,
    submitting,
    getMinDate,
    getMaxDate,
    ENUMS,
    title,
    submitLabel,
    showMapPicker,
    setShowMapPicker,
    setMapPickerFor,
    onLocationSelect,
    isEdit = false,
    dishes = []
}) => {
    const [dishSearchTerm, setDishSearchTerm] = useState(''); // ✅ Search state for dishes
    const availableDishes = dishes.filter(d => d.parentId !== null && d.parentId !== undefined);

    // Define styles inside the component
    const modalOverlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
        animation: 'fadeIn 0.25s ease',
    };

    const modalStyle = {
        background: '#fff',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '720px',
        maxHeight: '90vh',
        scrollbarWidth: "none",
        overflow: 'auto',
        boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.3s ease',
    };

    const modalHeaderStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px 24px',
        borderBottom: '1px solid #F3F4F6',
        position: 'sticky',
        top: 0,
        background: '#fff',
        zIndex: 1,
    };

    const modalHeaderLeftStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    };

    const modalHeaderIconStyle = {
        width: '36px',
        height: '36px',
        borderRadius: '10px',
        background: 'linear-gradient(135deg, #e66d33, #e66d33)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
    };

    const modalTitleStyle = {
        margin: 0,
        fontSize: '18px',
        fontWeight: 700,
        color: '#111827',
    };

    const modalCloseStyle = {
        background: '#F3F4F6',
        border: 'none',
        fontSize: '16px',
        cursor: 'pointer',
        color: '#6B7280',
        padding: '6px 10px',
        borderRadius: '8px',
        transition: 'all 0.2s ease',
    };

    const modalBodyStyle = {
        padding: '24px',
    };

    const formRowStyle = {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '14px',
        marginBottom: '14px',
    };

    const formGroupStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
    };

    const labelStyle = {
        fontSize: '13px',
        fontWeight: 500,
        color: '#374151',
    };

    const inputStyle = {
        padding: '10px 12px',
        border: '1px solid #E5E7EB',
        borderRadius: '8px',
        fontSize: '14px',
        outline: 'none',
        transition: 'all 0.2s ease',
        background: '#fff',
        color: '#111827',
    };

    const selectStyle = {
        ...inputStyle,
        appearance: 'auto',
    };

    const textareaStyle = {
        ...inputStyle,
        resize: 'vertical',
        fontFamily: 'inherit',
        width: '100%',
    };

    const sectionStyle = {
        marginBottom: '20px',
        paddingBottom: '20px',
        borderBottom: '1px solid #F3F4F6',
    };

    const sectionTitleStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        fontWeight: 600,
        color: '#374151',
        marginBottom: '12px',
    };

    const checkboxStyle = {
        width: '16px',
        height: '16px',
        accentColor: '#e66d33',
        cursor: 'pointer',
    };

    const checkboxLabelStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        flex: 1,
    };

    const addonCardStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px 12px',
        background: '#F9FAFB',
        borderRadius: '8px',
        border: '1px solid #F3F4F6',
    };

    const addonsGridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '8px',
    };

    const addonQuantityStyle = {
        width: '60px',
        padding: '4px 8px',
        border: '1px solid #E5E7EB',
        borderRadius: '6px',
        fontSize: '13px',
        textAlign: 'center',
        background: '#fff',
    };

    const dishesGridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '6px',
        maxHeight: '160px',
        overflowY: 'auto',
        padding: '4px 2px',
    };

    const dishCheckboxStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '6px 10px',
        background: '#F9FAFB',
        border: '1px solid #F3F4F6',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '13px',
        transition: 'all 0.2s ease',
    };

    const dishPriceStyle = {
        fontSize: '11px',
        color: '#6B7280',
        marginLeft: 'auto',
        fontWeight: 500,
    };

    const noDishesStyle = {
        color: '#9CA3AF',
        fontSize: '13px',
        padding: '8px 0',
    };

    const formActionStyle = {
        display: 'flex',
        gap: '12px',
        justifyContent: 'space-between',
        paddingTop: '16px',
    };

    const cancelButtonStyle = {
        padding: '10px 24px',
        background: '#F3F4F6',
        color: '#4B5563',
        border: 'none',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
    };

    const submitButtonStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 28px',
        background: 'linear-gradient(135deg, #e66d33, #e66d33)',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
    };

    return (
        <div style={modalOverlayStyle} onClick={() => setShowModal(false)}>
            <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
                <div style={modalHeaderStyle}>
                    <div style={modalHeaderLeftStyle}>
                        <div style={modalHeaderIconStyle}>
                            {isEdit ? <FaEdit size={18} /> : <FaPlus size={18} />}
                        </div>
                        <h3 style={modalTitleStyle}>{title}</h3>
                    </div>
                    <button onClick={() => setShowModal(false)} style={modalCloseStyle}>
                        <FaTimes />
                    </button>
                </div>

                <form onSubmit={handleSubmit} style={modalBodyStyle}>
                    {/* Source */}
                    <div style={formRowStyle}>
                        <div style={formGroupStyle}>
                            <label style={labelStyle}>Source <span style={{ color: '#EF4444' }}>*</span></label>
                            <select
                                name="source"
                                value={formData.source || 'APP'}
                                onChange={handleInputChange}
                                style={selectStyle}
                                required
                            >
                                {ENUMS.source.map(s => (
                                    <option key={s} value={s}>{s.replace('_', ' ')}</option>
                                ))}
                            </select>
                        </div>
                        <div style={formGroupStyle}>
                            <label style={labelStyle}>Source By</label>
                            <input
                                name="sourceBy"
                                value={formData.sourceBy || ''}
                                onChange={handleInputChange}
                                style={inputStyle}
                                placeholder="Reference"
                            />
                        </div>
                    </div>

                    {/* Customer Details */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaUser size={15} />
                            <span>Customer Details</span>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Full Name <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="fullName"
                                    value={formData.fullName || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="John Doe"
                                    required
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Email <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="email"
                                    type="email"
                                    value={formData.email || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="john@example.com"
                                    required
                                />
                            </div>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Phone Number <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="phoneNumber"
                                    value={formData.phoneNumber || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="+91 98765 43210"
                                    required
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Company Name</label>
                                <input
                                    name="companyName"
                                    value={formData.companyName || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="Company name"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Event Details */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaCalendarAlt size={15} />
                            <span>Event Details</span>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Event <span style={{ color: '#EF4444' }}>*</span></label>
                                <select
                                    name="event"
                                    value={formData.event || 'EVENT'}
                                    onChange={handleInputChange}
                                    style={selectStyle}
                                    required
                                >
                                    {ENUMS.event.map(e => (
                                        <option key={e} value={e}>{e}</option>
                                    ))}
                                </select>
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Event Type <span style={{ color: '#EF4444' }}>*</span></label>
                                <select
                                    name="eventType"
                                    value={formData.eventType || (formData.event === 'DAILY' ? 'DAILY' : 'WEDDING')}
                                    onChange={handleInputChange}
                                    style={selectStyle}
                                    required
                                >
                                    {formData.event === 'DAILY' ? (
                                        ['DAILY', 'WEEKLY', 'MONTHLY', 'CORPORATE', 'OTHER'].map(e => (
                                            <option key={e} value={e}>{e}</option>
                                        ))
                                    ) : (
                                        ENUMS.eventType.filter(e => !['DAILY', 'WEEKLY', 'MONTHLY', 'CORPORATE'].includes(e)).map(e => (
                                            <option key={e} value={e}>{e}</option>
                                        ))
                                    )}
                                </select>
                            </div>
                        </div>

                        {formData.event === 'EVENT' ? (
                            <div style={formRowStyle}>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Event Date <span style={{ color: '#EF4444' }}>*</span></label>
                                    <input
                                        name="eventDate"
                                        type="date"
                                        value={formData.eventDate || ''}
                                        onChange={handleInputChange}
                                        style={inputStyle}
                                        min={getMinDate()}
                                        max={getMaxDate()}
                                        required
                                    />
                                </div>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Event Time</label>
                                    <input
                                        name="eventTime"
                                        type="time"
                                        value={formData.eventTime || ''}
                                        onChange={handleInputChange}
                                        style={inputStyle}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div style={formRowStyle}>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>From Date <span style={{ color: '#EF4444' }}>*</span></label>
                                    <input
                                        name="fromDate"
                                        type="date"
                                        value={formData.fromDate || ''}
                                        onChange={handleInputChange}
                                        style={inputStyle}
                                        min={getMinDate()}
                                        max={getMaxDate()}
                                        required
                                    />
                                </div>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>To Date <span style={{ color: '#EF4444' }}>*</span></label>
                                    <input
                                        name="toDate"
                                        type="date"
                                        value={formData.toDate || ''}
                                        onChange={handleInputChange}
                                        style={inputStyle}
                                        min={getMinDate()}
                                        max={getMaxDate()}
                                        required
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Venue Details */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaMapMarkerAlt size={15} />
                            <span>Venue Details</span>
                        </div>
                        <div style={formGroupStyle}>
                            <label style={labelStyle}>Full Address <span style={{ color: '#EF4444' }}>*</span></label>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <textarea
                                    name="fullAddress"
                                    value={formData.fullAddress || ''}
                                    onChange={handleInputChange}
                                    style={{ ...textareaStyle, flex: 1 }}
                                    rows="2"
                                    placeholder="123 Main St, City"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (typeof setShowMapPicker === 'function' && typeof setMapPickerFor === 'function') {
                                            setMapPickerFor(isEdit ? 'edit' : 'create');
                                            setShowMapPicker(true);
                                        }
                                    }}
                                    style={{
                                        padding: '10px 14px',
                                        background: '#e66d33',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '20px',
                                        minHeight: '56px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'all 0.2s ease',
                                        flexShrink: 0,
                                    }}
                                    title="Select location on map"
                                    onMouseEnter={(e) => e.currentTarget.style.background = '#d45f2a'}
                                    onMouseLeave={(e) => e.currentTarget.style.background = '#e66d33'}
                                >
                                    <FaMapMarkerAlt />
                                </button>
                            </div>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>City <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="city"
                                    value={formData.city || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="Mumbai"
                                    required
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>State <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="state"
                                    value={formData.state || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="Maharashtra"
                                    required
                                />
                            </div>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Country</label>
                                <input
                                    name="country"
                                    value={formData.country || 'India'}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Pincode <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="pincode"
                                    type="number"
                                    value={formData.pincode || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="400001"
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    {/* Plate Count & Budget */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaUtensils size={15} />
                            <span>Plate Count & Budget</span>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Veg Plates</label>
                                <input
                                    name="vegPlates"
                                    type="number"
                                    value={formData.vegPlates || 0}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    min="0"
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Non-Veg Plates</label>
                                <input
                                    name="nonVegPlates"
                                    type="number"
                                    value={formData.nonVegPlates || 0}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    min="0"
                                />
                            </div>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Mixed Plates</label>
                                <input
                                    name="mixedPlates"
                                    type="number"
                                    value={formData.mixedPlates || 0}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    min="0"
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Budget (₹)</label>
                                <input
                                    name="budget"
                                    type="number"
                                    value={formData.budget || 0}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    min="0"
                                    placeholder="0"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Add-ons Section */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaCheckCircle size={15} />
                            <span>Add-ons</span>
                        </div>
                        <div style={addonsGridStyle}>
                            {addOns.map((addon, index) => (
                                <div key={index} style={addonCardStyle}>
                                    <label style={checkboxLabelStyle}>
                                        <input
                                            type="checkbox"
                                            checked={addon.selected}
                                            onChange={() => handleAddOnToggle(index)}
                                            style={checkboxStyle}
                                        />
                                        <span style={{ fontWeight: 500, fontSize: '13px' }}>{addon.label}</span>
                                    </label>
                                    {addon.selected && (
                                        <input
                                            type="number"
                                            value={addon.quantity}
                                            onChange={(e) => handleAddOnQuantity(index, e.target.value)}
                                            style={addonQuantityStyle}
                                            min="1"
                                            placeholder="Qty"
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Dishes Section with Search */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaUtensils size={15} />
                            <span>Select Dishes</span>
                        </div>
                        
                        {/* ✅ Search Bar */}
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '8px',
                            marginBottom: '12px',
                            padding: '6px 12px',
                            background: '#F9FAFB',
                            borderRadius: '8px',
                            border: '1px solid #E5E7EB',
                        }}>
                            <FaSearch style={{ color: '#9CA3AF', fontSize: '14px' }} />
                            <input
                                type="text"
                                placeholder="Search dishes..."
                                value={dishSearchTerm}
                                onChange={(e) => setDishSearchTerm(e.target.value)}
                                style={{
                                    flex: 1,
                                    padding: '6px 0',
                                    border: 'none',
                                    outline: 'none',
                                    fontSize: '13px',
                                    background: 'transparent',
                                    color: '#111827',
                                }}
                            />
                            {dishSearchTerm && (
                                <FaTimes 
                                    onClick={() => setDishSearchTerm('')}
                                    style={{ 
                                        color: '#9CA3AF', 
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        padding: '2px'
                                    }}
                                />
                            )}
                        </div>

                        <div style={dishesGridStyle}>
                            {availableDishes.length === 0 ? (
                                <div style={noDishesStyle}>No dishes available</div>
                            ) : (
                                availableDishes
                                    .filter(dish => 
                                        dish.dishName.toLowerCase().includes(dishSearchTerm.toLowerCase())
                                    )
                                    .map(dish => (
                                        <label key={dish.dishId} style={dishCheckboxStyle}>
                                            <input
                                                type="checkbox"
                                                checked={selectedDishIds.includes(dish.dishId)}
                                                onChange={() => handleDishSelect(dish.dishId)}
                                                style={checkboxStyle}
                                            />
                                            <span style={{ fontWeight: 500 }}>{dish.dishName}</span>
                                            <span style={dishPriceStyle}>₹{dish.effectivePrice || dish.dishPrice}</span>
                                        </label>
                                    ))
                            )}
                        </div>
                    </div>

                    {/* Additional Requests */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaEdit size={15} />
                            <span>Additional Requests</span>
                        </div>
                        <textarea
                            name="additionalRequests"
                            value={formData.additionalRequests || ''}
                            onChange={handleInputChange}
                            style={textareaStyle}
                            rows="2"
                            placeholder="Any special requests or requirements..."
                        />
                    </div>

                    {/* GST Requirement */}
                    <div style={formGroupStyle}>
                        <label style={labelStyle}>GST Requirement</label>
                        <input
                            name="gstRequirement"
                            value={formData.gstRequirement || ''}
                            onChange={handleInputChange}
                            style={inputStyle}
                            placeholder="GST number if applicable"
                        />
                    </div>

                    {/* Form Actions */}
                    <div style={formActionStyle}>
                        <button
                            type="button"
                            onClick={() => { resetForm(); setShowModal(false); }}
                            style={cancelButtonStyle}
                        >
                            Cancel
                        </button>
                        <button type="submit" style={submitButtonStyle} disabled={submitting}>
                            {submitting ? (
                                <>
                                    <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
                                    {isEdit ? 'Updating...' : 'Creating...'}
                                </>
                            ) : (
                                <>
                                    {isEdit ? <FaEdit size={14} /> : <FaPlus size={14} />}
                                    {submitLabel}
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

// ─── Styles ──────────────────────────────────────────────────────
const containerStyle = {
    height: "65vh",
    scrollbarWidth: "thin",
};

const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '16px',
};

const headerLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
};

const headerIconStyle = {
    width: '44px',
    height: '44px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
};

const titleStyle = {
    fontSize: '24px',
    fontWeight: 700,
    color: '#111827',
    margin: 0,
    letterSpacing: '-0.5px',
};

const subtitleStyle = {
    fontSize: '14px',
    color: '#6B7280',
    margin: '4px 0 0 0',
};

const createButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 24px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontWeight: 600,
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
};

const statsContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gap: '16px',
    marginBottom: '16px',
};

const statCardStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    background: '#fff',
    padding: '18px 20px',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    border: '1px solid #E5E7EB',
    transition: 'all 0.2s ease',
};

const statIconWrapperStyle = {
    width: '44px',
    height: '44px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const statNumberStyle = {
    fontSize: '22px',
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1.2,
};

const statLabelStyle = {
    fontSize: '13px',
    color: '#6B7280',
    fontWeight: 500,
};

const searchFilterContainerStyle = {
    display: 'flex',
    gap: '12px',
    marginBottom: '16px',
    flexWrap: 'wrap',
    alignItems: 'center',
};

const searchContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: '200px',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    padding: '0 16px',
    transition: 'all 0.2s ease',
};

const searchIconStyle = {
    color: '#9CA3AF',
    marginRight: '12px',
};

const searchInputStyle = {
    flex: 1,
    padding: '11px 0',
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    background: 'transparent',
    color: '#111827',
};

const dateFilterContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    padding: '4px 14px',
    flexWrap: 'wrap',
};

const dateInputStyle = {
    padding: '8px 8px',
    border: 'none',
    outline: 'none',
    fontSize: '13px',
    background: 'transparent',
    color: '#111827',
    width: '120px',
};

const dateSeparatorStyle = {
    color: '#9CA3AF',
    fontSize: '13px',
};

const clearButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 12px',
    background: '#FEE2E2',
    color: '#DC2626',
    border: 'none',
    borderRadius: '6px',
    fontSize: '12px',
    cursor: 'pointer',
    fontWeight: 500,
    transition: 'all 0.2s ease',
};

const filterIconStyle = {
    color: '#6B7280',
    fontSize: '13px',
};

const tableCardStyle = {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    border: '1px solid #E5E7EB',
};

const tableWrapperStyle = {
    overflowX: 'auto',
    padding: '0',
    maxHeight: '50vh',
    scrollbarWidth: 'thin',
};

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '1100px',
};

const thStyle = {
    padding: '12px 16px',
    fontSize: '12px',
    fontWeight: 600,
    color: '#6B7280',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    background: '#F9FAFB',
    borderBottom: '1px solid #E5E7EB',
};

const tdStyle = {
    padding: '12px 16px',
    fontSize: '13px',
    color: '#111827',
    borderBottom: '1px solid #F3F4F6',
};

const tableRowStyle = {
    transition: 'background 0.15s ease',
    cursor: 'default',
};

const customerCellStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
};

const avatarStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: 600,
    flexShrink: 0,
};

const sourceBadgeStyle = {
    display: 'inline-block',
    padding: '2px 10px',
    background: '#F3F4F6',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#4B5563',
};

const eventBadgeStyle = {
    display: 'inline-block',
    padding: '2px 10px',
    background: '#F3F4F6',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#4B5563',
};

const cityBadgeStyle = {
    display: 'inline-block',
    padding: '2px 10px',
    background: '#EEF2FF',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#4F46E5',
};

const emptyStateStyle = {
    padding: '60px 20px',
    textAlign: 'center',
    borderBottom: 'none',
};

const emptyStateContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
};

const loadingStyle = {
    padding: '60px 20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    color: '#6B7280',
};

const actionGroupStyle = {
    display: 'flex',
    gap: '6px',
    justifyContent: 'center',
    flexWrap: 'wrap',
};

const viewButtonStyle = {
    padding: '6px 10px',
    background: '#60A5FA',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const editButtonStyle = {
    padding: '6px 10px',
    background: '#34D399',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const deleteButtonStyle = {
    padding: '6px 10px',
    background: '#F87171',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px',
    animation: 'fadeIn 0.25s ease',
};

const modalStyle = {
    background: '#fff',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '720px',
    maxHeight: '90vh',
    scrollbarWidth: "none",
    overflow: 'auto',
    boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
    animation: 'slideUp 0.3s ease',
};

const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #F3F4F6',
    position: 'sticky',
    top: 0,
    background: '#fff',
    zIndex: 1,
};

const modalHeaderLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
};

const modalHeaderIconStyle = {
    width: '36px',
    height: '36px',
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
};

const modalTitleStyle = {
    margin: 0,
    fontSize: '18px',
    fontWeight: 700,
    color: '#111827',
};

const modalCloseStyle = {
    background: '#F3F4F6',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    color: '#6B7280',
    padding: '6px 10px',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
};

const modalBodyStyle = {
    padding: '24px',
};

const formActionStyle = {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
    marginTop: '8px',
    paddingTop: '16px',
    borderTop: '1px solid #F3F4F6',
};

const cancelButtonStyle = {
    padding: '10px 24px',
    background: '#F3F4F6',
    color: '#4B5563',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

const submitButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 28px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
};

const viewSectionStyle = {
    border: '1px solid #F3F4F6',
    borderRadius: '8px',
    padding: '14px 16px',
    marginBottom: '12px',
};

const viewSectionTitleStyle = {
    margin: '0 0 10px 0',
    fontSize: '14px',
    fontWeight: 600,
    color: '#1E293B',
};

const viewGridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px 16px',
};

const customDateModalOverlay = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: '20px',
    animation: 'fadeIn 0.25s ease',
};

const customDateModalStyle = {
    background: '#fff',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
    animation: 'slideUp 0.3s ease',
};

const customDateModalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #F3F4F6',
};

const customDateModalTitle = {
    margin: 0,
    fontSize: '18px',
    fontWeight: 700,
    color: '#111827',
};

const customDateModalClose = {
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#6B7280',
    padding: '4px 8px',
    transition: 'color 0.2s ease',
};

const customDateModalBody = {
    padding: '24px',
};

const customDateModalInputGroup = {
    marginBottom: '16px',
};

const customDateModalLabel = {
    display: 'block',
    fontSize: '13px',
    fontWeight: 500,
    color: '#374151',
    marginBottom: '6px',
};

const customDateModalInput = {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s ease',
    background: '#fff',
    color: '#111827',
    boxSizing: 'border-box',
};

const customDateModalFooter = {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    padding: '16px 24px',
    borderTop: '1px solid #F3F4F6',
};

const customDateModalCancel = {
    padding: '8px 20px',
    background: '#F3F4F6',
    color: '#4B5563',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

const customDateModalApply = {
    padding: '8px 24px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(230, 109, 51, 0.3)',
};

const filterSelectStyle = {
    padding: '7px 4px',
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    background: 'transparent',
    cursor: 'pointer',
    color: '#111827',
    appearance: 'none',
    paddingRight: '4px',
};

export default ManagerEnquiry;